<template>
  <div class="wrapper">
    <header class="main-header">
      <a href="#" v-on:click.prevent="" class="logo hidden-xs">
        <!-- mini logo for sidebar mini 50x50 pixels -->
        <span class="logo-mini font-extra">
          <img :src="`${baseUrl}Content/Images/PNG/LogoSmall.png`" width="50" height="50"
               style="padding-right:10px;" />
        </span>
        <!-- logo for regular state and mobile devices -->
        <span class="logo-lg log font-extra">{{ ui.csm_layout_app_name }}</span>
      </a>
      <nav class="navbar navbar-static-top">
        <a href="#" class="sidebar-toggle" data-toggle="push-menu" role="button" style="padding-top:16px">
          <span class="sr-only">{{ ui.csm_layout_toggle_nav }}</span>
          <span class="hidden-md hidden-sm hidden-xs font-extra rn-page-title" style="margin-left: 10px">{{ pageTitle }}</span>
        </a>

        <!-- หัวเมนู -->
        <div class="navbar-custom-menu">
          <ul class="nav navbar-nav rn-nav-overflow" :class="{ 'rn-open': showNavMore }">
            <li v-if="!xt.isEmpty(auth.extension)">
              <select class="form-control" v-model="viewStatus" @change="setState()" style="width:150px">
                <option value="" selected="selected" disabled="disabled">{{ ui.csm_layout_select }}</option>
                <option v-for="x in stateData" :key="x.state_code" :value="x.state_code"
                        v-show="x.state_code != '11' && x.state_code != '12'">
                  {{ x.state_name }}
                </option>
              </select>
      
            </li>
            <li v-if="!xt.isEmpty(auth.extension)">
              <a href="#" @click.prevent="">
                <i class="fa fa-phone"></i> {{ ui.csm_layout_extension }} : {{ auth.extension || '' }}
              </a>
            </li>
            <!-- เครื่องมือ : รวมเมนูตั้งค่า / IT / Admin / Logs ไว้ในปุ่มเดียว -->
            <li class="cm-launcher" v-if="toolsGroups.length > 0"
                @mouseenter="openToolsPanel()" @mouseleave="scheduleCloseToolsPanel()">
              <a href="#" class="cm-launcher__btn" :class="{ 'is-open': showToolsPanel }"
                 :title="ui.csm_layout_tools_menu" :aria-expanded="showToolsPanel ? 'true' : 'false'"
                 @click.prevent="toggleToolsPanel()">
                <i class="fas fa-th-large cm-launcher__grid"></i>
                <span class="cm-launcher__label">{{ ui.csm_layout_tools_menu }}</span>
                <i class="fas fa-angle-down cm-launcher__caret"></i>
              </a>
              <div class="cm-panel" v-show="showToolsPanel">
                <div class="cm-panel__group" v-for="g in toolsGroups" :key="g.key" :style="{ '--mc': g.color }">
                  <div class="cm-panel__title">
                    <span class="cm-panel__title-ico"><i :class="g.icon"></i></span>
                    <span>{{ g.text }}</span>
                  </div>
                  <div class="cm-panel__grid">
                    <a v-for="x in g.items" :key="x.code" class="cm-panel__chip"
                       :href="baseUrl + x.link" target="_blank" :title="x.text">
                      <span class="cm-panel__chip-ico"><i :class="x.icon"></i></span>
                      <span class="cm-panel__chip-body">
                        <span class="cm-panel__chip-code">{{ x.code }}</span>
                        <span class="cm-panel__chip-text">{{ x.text }}</span>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </li>

            <li>
              <a :href="baseUrl+'page/transaction/v_csm_trn_002'" target="_blank">
                <i class="fas fa-file-alt"></i>
                <span class="label label-warning" v-if="totalCSMLine > 0">{{ totalCSMLine }}</span>
        
              </a>
            </li>
          </ul>
       <div class="rn-nav-backdrop" v-if="showNavMore" @click="showNavMore = false"></div>
 

          <ul class="nav navbar-nav rn-nav-primary">
            <li class="rn-more">
              <a href="#" :class="{ 'rn-more--on': showNavMore }" @click.prevent="showNavMore = !showNavMore">
                <i class="fas fa-ellipsis-v"></i>
              </a>
            </li>
            <!-- แจ้งเตือน เมื่อมีการกรอกเลข prod -->
            <li v-if="is_mango() && notiRevProd.length > 0">
              <a href="#" :title="ui.csm_layout_rev_prod_count.replace('{0}', notiRevProd.length)" @click.prevent="openRevProdModal()">
                <i class="fas fa-code-branch"></i>
                <span class="label label-warning">{{ notiRevProd.length }}</span>
              </a>
            </li>
            <!-- แจ้งเตือน เมื่อถูก # มอบหมาย หรือ @ กล่าวถึง ในเคส -->
            <li class="dropdown notifications-menu rn-noti rn-tag" v-if="is_mango() && notiTagCount > 0">
              <a href="#" class="dropdown-toggle rn-noti__bell" data-toggle="dropdown"
                 :title="ui.csm_noti_tag_title">
                <i class="fas fa-at"></i>
                <span class="rn-noti__badge rn-tag__badge" :class="{ 'rn-tag__badge--soft': !notiTag.count_assign }">
                  {{ notiTagCount }}
                </span>
              </a>

              <ul class="dropdown-menu rn-noti__panel rn-tp">
                <li class="rn-tp__head">
                  <span class="rn-tp__head-title">{{ ui.csm_noti_panel_title }}</span>
                  <span class="rn-tp__pill">{{ notiTagReadLabel }}</span>
                  <button type="button" class="rn-tp__close" :title="ui.erp_close" @click="closeNotiPanel($event)">
                    <i class="fas fa-times"></i>
                  </button>
                </li>
                <li class="rn-tp__bar">
                  <span class="rn-tp__day">{{ notiTagDayLabel }}</span>
                  <button type="button" class="rn-tp__mark" v-if="notiTag.count_mention > 0" @click="markAllNotiTagRead()">
                    <i class="fas fa-check-double"></i> {{ ui.csm_noti_mark_all_read }}
                  </button>
                </li>
                <li class="rn-tp__scroll">
                  <div class="rn-tp__group rn-tp__group--assign">
                    <div class="rn-tp__group-head">{{ ui.csm_noti_assign_label }} · {{ notiTag.count_assign || 0 }}</div>
                    <a href="#" class="rn-tp__item" v-for="x in notiTag.assign" :key="'a' + x.notify_id"
                       @click.prevent="openNotiTag(x)">
                      <span class="rn-tp__tile"><i class="fas fa-user-check"></i></span>
                      <span class="rn-tp__body">
                        <span class="rn-tp__kicker">{{ ui.csm_noti_assign_label }}</span>
                        <span class="rn-tp__title">{{ ui.erp_document_no }} <b>{{ x.job_no }}</b></span>
                        <span class="rn-tp__text" v-show="!xt.isEmpty(x.subject)">{{ x.subject }}</span>
                        <span class="rn-tp__text rn-tp__text--quote" v-show="!xt.isEmpty(x.comment_text)">{{ x.comment_text }}</span>
                        <span class="rn-tp__meta">{{ x.from_name }} · {{ notiTagAgo(x.add_dt) }}</span>
                        <span class="rn-tp__chip"><i class="far fa-clock"></i> {{ ui.csm_noti_wait_check }}</span>
                      </span>
                    </a>
                    <div class="rn-tp__empty" v-if="!notiTag.assign.length">
                      <i class="far fa-bell-slash"></i>
                      <span>{{ ui.csm_noti_no_assign }}</span>
                    </div>
                  </div>
                  <div class="rn-tp__group rn-tp__group--mention">
                    <div class="rn-tp__group-head">{{ ui.csm_noti_mention_label }} · {{ notiTag.count_mention || 0 }}</div>
                    <a href="#" class="rn-tp__item" v-for="x in notiTag.mention" :key="'m' + x.notify_id"
                       @click.prevent="openNotiTag(x)">
                      <span class="rn-tp__tile"><i class="fas fa-at"></i></span>
                      <span class="rn-tp__body">
                        <span class="rn-tp__kicker">{{ ui.csm_noti_mention_label }}</span>
                        <span class="rn-tp__title">{{ ui.erp_document_no }} <b>{{ x.job_no }}</b></span>
                        <span class="rn-tp__text rn-tp__text--quote" v-show="!xt.isEmpty(x.comment_text)">{{ x.comment_text }}</span>
                        <span class="rn-tp__meta">{{ x.from_name }} · {{ notiTagAgo(x.add_dt) }}</span>
                      </span>
                    </a>
                    <div class="rn-tp__empty" v-if="!notiTag.mention.length">
                      <i class="far fa-bell-slash"></i>
                      <span>{{ ui.csm_noti_no_mention }}</span>
                    </div>
                  </div>
                </li>
                <li class="rn-tp__foot">
                  <span>{{ (ui.csm_noti_showing_count || '').replace('{0}', notiTagCount) }}</span>
                  <span>{{ ui.csm_noti_updated_at }} · {{ notiTagUpdatedAgo }}</span>
                </li>
              </ul>
            </li>
            <!-- แจ้งเตือน เมื่อมี Comment ใหม่ใน task ที่เราเกี่ยวข้อง -->
            <li class="dropdown notifications-menu rn-noti rn-cmt" v-if="notiCommentEnabled && notiComment.length > 0">
              <a href="#" class="dropdown-toggle rn-noti__bell" data-toggle="dropdown"
                 :title="ui.csm_noti_comment_title">
                <i class="fas fa-comments"></i>
                <span class="rn-noti__badge rn-cmt__badge">{{ notiComment.length }}</span>
              </a>

              <ul class="dropdown-menu rn-noti__panel rn-tp rn-tp--cmt">
                <li class="rn-tp__head">
                  <span class="rn-tp__head-title">{{ ui.csm_noti_panel_title }}</span>
                  <span class="rn-tp__pill">{{ notiCommentReadLabel }}</span>
                  <button type="button" class="rn-tp__close" :title="ui.erp_close" @click="closeNotiPanel($event)">
                    <i class="fas fa-times"></i>
                  </button>
                </li>
                <li class="rn-tp__bar">
                  <span class="rn-tp__day">{{ notiCommentDayLabel }}</span>
                  <button type="button" class="rn-tp__mark" @click="markAllNotiCommentRead()">
                    <i class="fas fa-check-double"></i> {{ ui.csm_noti_mark_all_read }}
                  </button>
                </li>
                <li class="rn-tp__scroll">
                  <div class="rn-tp__group rn-tp__group--comment">
                    <div class="rn-tp__group-head">{{ ui.csm_noti_comment_label }} · {{ notiComment.length }}</div>
                    <a href="#" class="rn-tp__item" v-for="x in notiComment" :key="'c' + x.notify_id"
                       @click.prevent="openNotiComment(x)">
                      <span class="rn-tp__tile"><i class="fas fa-comments"></i></span>
                      <span class="rn-tp__body">
                        <span class="rn-tp__kicker">{{ ui.csm_noti_comment_label }}</span>
                        <span class="rn-tp__title">{{ ui.erp_document_no }} <b>{{ x.job_no }}</b></span>
                        <span class="rn-tp__text" v-show="!xt.isEmpty(x.task_subject || x.subject)">#{{ x.ref_itemno }} {{ x.task_subject || x.subject }}</span>
                        <span class="rn-tp__text rn-tp__text--quote" v-show="!xt.isEmpty(x.comment_text)">{{ x.comment_text }}</span>
                        <span class="rn-tp__meta">{{ x.from_name }} · {{ notiTagAgo(x.add_dt) }}</span>
                        <span class="rn-tp__chip" v-if="xt.int(x.unread_count) > 1">
                          <i class="far fa-comment-dots"></i> {{ (ui.csm_noti_comment_more || '').replace('{0}', x.unread_count) }}
                        </span>
                      </span>
                    </a>
                    <div class="rn-tp__empty" v-if="!notiComment.length">
                      <i class="far fa-bell-slash"></i>
                      <span>{{ ui.csm_noti_no_comment }}</span>
                    </div>
                  </div>
                </li>
                <li class="rn-tp__foot">
                  <span>{{ (ui.csm_noti_showing_count || '').replace('{0}', notiComment.length) }}</span>
                  <span>{{ ui.csm_noti_updated_at }} · {{ notiCommentUpdatedAgo }}</span>
                </li>
              </ul>
            </li>
                    <!-- แจ้งเตือน เมื่อมี Comment DueDate -->
            <li class="dropdown notifications-menu rn-noti"> 
              <a href="#" class="dropdown-toggle rn-noti__bell" data-toggle="dropdown">
                <i class="fas fa-bell"></i>
                <span class="rn-noti__badge" v-if="viewNotiDueDate.length > 0">
                  {{ viewNotiDueDate.length || 0 }} 
                </span>
              </a>
              
              <ul class="dropdown-menu rn-noti__panel rn-du">
                <li class="rn-du__head">
                  <span class="rn-du__head-ico"><i class="far fa-clock"></i></span>
                  <span class="rn-du__head-text">
                    <span class="rn-du__head-title">{{ ui.csm_noti_due_title }}</span>
                    <span class="rn-du__head-sub">{{ ui.csm_noti_due_subtitle }}</span>
                  </span>
                  <span class="rn-du__head-count">{{ viewNotiDueDate.length || 0 }}</span>
                </li>
                <li class="rn-du__bar">
                  <span>{{ ui.csm_noti_due_list_label }}</span>
                  <span class="rn-du__sort"><i class="far fa-clock"></i> {{ ui.csm_noti_due_sorted }}</span>
                </li>
                <li class="rn-du__scroll">
                  <a class="rn-du__item" v-for="(x, idx) in notiDueDateSorted" :key="idx"
                     :href="baseUrl + 'page/transaction/v_csm_trn_001/?job_no=' + x.job_no" target="_blank">
                    <span class="rn-du__tile"><i class="fas fa-file-alt"></i></span>
                    <span class="rn-du__body">
                      <span class="rn-du__no">{{ x.job_no }}</span>
                      <span class="rn-du__meta" v-show="!xt.isEmpty(x.pre_des)"><i class="fas fa-th-large"></i> {{ x.pre_des }}</span>
                      <span class="rn-du__meta" v-show="!xt.isEmpty(x.dpt_name)"><i class="fas fa-sitemap"></i> {{ x.dpt_name }}</span>
                      <span class="rn-du__chip" v-if="x.alr_duedate">
                        <i class="far fa-clock"></i> {{ ui.erp_due_date }} {{ x.alr_duedate | date('DD/MM/YYYY') }}
                      </span>
                    </span>
                    <i class="fas fa-chevron-right rn-du__go"></i>
                  </a>
                  <div class="rn-du__empty" v-if="!viewNotiDueDate.length">
                    <i class="far fa-bell-slash"></i>
                    <span>{{ ui.erp_no_data }}</span>
                  </div>
                </li>
                <li class="rn-du__foot">
                  <span>{{ (ui.csm_noti_due_preview || '').replace('{0}', notiDuePreviewCount).replace('{1}', viewNotiDueDate.length || 0) }}</span>
                  <button type="button" class="rn-du__close" @click="closeNotiPanel($event)">{{ ui.csm_noti_close_panel }}</button>
                </li>
              </ul>
            </li>
            <li>
              <a href="#" data-toggle="control-sidebar">
                <img :src="`${baseUrl}Content/Images/Icon SVG/man.svg`" width="20" /> <span class="hidden-md hidden-sm hidden-xs">{{ (auth.userid || '').toUpperCase() }}</span>
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </header>
    <aside class="main-sidebar">
      <section class="sidebar">
        <div class="user-panel">
          <div class="image">
            <img :src="`${baseUrl}Content/Images/Icon PNG/man.png`" width="160" class="img-circle" />
          </div>
          <div class="info">
            <p :title="auth.empname">{{ auth.empname }}</p>
            <a href="#" @click.prevent><i class="fa fa-circle text-success"></i> {{ ui.csm_layout_online }}</a>
          </div>
        </div>
        <side-menu ref="sideMenu" :is-mango="is_mango()"></side-menu>
      </section>
    </aside>
    <div class="content-wrapper rn-content-wrapper">
      <!--Main content-->
      <section class="content">
        <div class="content-body" ref="content_body">
          <slot name="body"></slot>
        </div>
      </section>
    </div>
    <!-- Layout : Footer -->
    <footer class="main-footer hidden-sm hidden-xs">
      <div class="footer-inner">
        <div class="footer-identity">
          <span class="footer-mark"><i class="fas fa-headset"></i></span>
          <div class="footer-identity-copy">
            <small>{{ ui.csm_layout_app_name }}</small>
            <div>
              <span>&copy; {{ year === 2019 ? '2019' : `2019-${year}` }}</span>
              <span class="footer-brand-name">Mango Consultant Co., Ltd.</span>
            </div>
          </div>
          <span class="footer-info-divider"></span>
          <span class="footer-company" :title="auth.mainname"><i class="fas fa-building"></i>{{ auth.mainname }}</span>
        </div>

        <div class="footer-context">
          <span class="footer-online">
            <span class="online-pulse"></span>
            <span>{{ ui.csm_layout_users_online }}</span>
            <strong>{{ onlineUser.current }}</strong>
            <small>/ {{ onlineUser.max }}</small>
          </span>
        </div>

        <div class="footer-builds">
          <span class="build-badge"><small>{{ ui.csm_layout_app_version }}</small><strong>{{ viewVersion }}</strong></span>
          <span class="build-divider"></span>
          <span class="build-badge"><small>{{ ui.csm_layout_api_version }}</small><strong>{{ appinfo.build_version }}</strong></span>
        </div>
      </div>
    </footer>
    <!-- Control Sidebar -->
    <aside class="control-sidebar control-sidebar-dark">
      <!-- Tabs -->
      <ul class="nav nav-tabs nav-justified control-sidebar-tabs cs-tabs">
        <li class="active"><a href="#control-sidebar-home-tab" data-toggle="tab"><i class="fa fa-user"></i></a></li>
        <!-- <li><a href="#control-sidebar-settings-tab" data-toggle="tab"><i class="fa fa-bell"></i></a></li> -->
        <li><a href="#control-sidebar-settings-tab-2" data-toggle="tab"><i class="fa fa-gears"></i></a></li>
      </ul>

      <div class="tab-content" style="padding: 0;">

        <!-- Tab: Profile -->
        <div class="tab-pane active" id="control-sidebar-home-tab">
          <!-- User card -->
          <div class="cs-user-card">
            <div class="cs-avatar">
              <img :src="`${baseUrl}Content/Images/Icon PNG/man.png`" />
            </div>
            <div class="cs-user-info">
              <div class="cs-user-name">{{ auth.empname }}</div>
              <div class="cs-user-status"><span class="cs-dot"></span> {{ ui.csm_layout_online }}</div>
            </div>
          </div>
          <!-- Section: Change Company -->
          <div class="cs-section-label"><i class="fas fa-building"></i> {{ ui.csm_layout_change_company }}</div>
          <div class="control-sidebar-company-section">
            <vue-select-2 :options="companyList"
                          :settings="{theme: 'bootstrap', selectionCssClass: 'form-control input-sm'}"
                          v-model="selectedMaincode">
            </vue-select-2>
            <button type="button"
                    class="btn btn-sm btn-primary btn-block margin-t-10"
                    @click="changeCompany()"
                    v-bind:disabled="isLoadingCompany">
              <i class="fa" v-bind:class="{'fa-spinner fa-spin': isLoadingCompany, 'fa-exchange-alt': !isLoadingCompany}"></i>
              {{ ui.csm_layout_confirm_change_company }}
            </button>
          </div>
          <div class="cs-section-label">{{ ui.csm_layout_quick_links }}</div>
          <ul class="control-sidebar-menu cs-menu">
            <li v-if="is_mango()">
              <a :href="baseUrl + 'page/customerdata/'" target="_blank">
                <span class="cs-icon bg-teal"><i class="fas fa-users"></i></span>
                <div class="menu-info">
                  <h4 class="control-sidebar-subheading">{{ ui.csm_layout_customer_data }}</h4>
                </div>
              </a>
            </li>
            <li v-if="is_mango()">
              <a :href="baseUrl + 'page/scheduleupdatesoftware/'" target="_blank">
                <span class="cs-icon bg-orange"><i class="fas fa-clock"></i></span>
                <div class="menu-info">
                  <h4 class="control-sidebar-subheading">{{ ui.csm_layout_schedule_update }}</h4>
                </div>
              </a>
            </li>
            <li v-if="is_mango() && isDeveloper()">
              <a :href="baseUrl + 'page/master/'" target="_blank">
                <span class="cs-icon bg-navy"><i class="fas fa-folder"></i></span>
                <div class="menu-info">
                  <h4 class="control-sidebar-subheading">{{ ui.master_data }}</h4>
                </div>
              </a>
            </li>
           <li v-if="is_mango() && isDeveloper()">
              <a :href="baseUrl + 'page/modules/'" target="_blank">
                <span class="cs-icon bg-navy"><i class="fas fa-file-contract"></i></span>
                <div class="menu-info">
                  <h4 class="control-sidebar-subheading">{{ ui.csm_layout_module_data }}</h4>
                </div>
              </a>
            </li>
            <li>
              <a href="#" @click.prevent="$refs.logout.openModal()">
                <span class="cs-icon bg-red"><i class="fa fa-sign-out-alt"></i></span>
                <div class="menu-info">
                  <h4 class="control-sidebar-subheading">{{ ui.log_out }}</h4>
                </div>
              </a>
            </li>
          </ul>
        </div>

        <!-- Tab: Notifications       ปิดก่อน -->
        <!-- <div class="tab-pane" id="control-sidebar-settings-tab">
          <div class="cs-section-label">{{ ui.notification }}</div>
        </div> -->

        <!-- Tab: Settings -->
        <div class="tab-pane" id="control-sidebar-settings-tab-2">
          <div class="cs-section-label">{{ ui.user_setting }}</div>
          <ul class="control-sidebar-menu cs-menu">
            <!-- <li>
              <a href="javascript:void(0)">
                <span class="cs-icon bg-yellow"><i class="fa fa-key"></i></span>
                <div class="menu-info">
                  <h4 class="control-sidebar-subheading">{{ ui.change_password }}</h4>
                </div>
              </a>
            </li> -->
            <li>
              <a href="#" @click.prevent="changeLanguage()">
                <span class="cs-icon bg-aqua"><i class="fa fa-globe"></i></span>
                <div class="menu-info">
                  <h4 class="control-sidebar-subheading">{{ ui.select_language }}</h4>
                </div>
              </a>
            </li>
            <li v-if="auth.userid.toUpperCase() == 'MANGO' || auth.is_admin">
              <a :href="dataServer" target="_blank">
                <span class="cs-icon bg-black"><i class="fas fa-database"></i></span>
                <div class="menu-info">
                  <h4 class="control-sidebar-subheading">{{ ui.csm_layout_database_program }}</h4>
                </div>
              </a>
            </li>
            <li >
              <a href="#" @click.prevent="toggleDarkMode">
                <span class="cs-icon" v-bind:class="isDarkMode ? 'bg-navy' : 'bg-black'">
                  <i :class="isDarkMode ? 'fas fa-sun' : 'fas fa-moon'"></i>
                </span>
                <div class="menu-info">
                  <h4 class="control-sidebar-subheading">{{ ui.csm_layout_dark_mode }}</h4>
                  <p>{{ isDarkMode ? 'On' : 'Off' }}</p>
                </div>
              </a>
            </li>
          </ul>

          <div class="cs-build-info">
            <div class="cs-build-row">
              <span class="cs-build-label">{{ ui.csm_layout_app_build }}</span>
              <span class="cs-build-value">{{ viewVersion }}</span>
            </div>
            <div class="cs-build-row">
              <span class="cs-build-label">{{ ui.csm_layout_api_build }}</span>
              <span class="cs-build-value">{{ appinfo.build_version }}</span>
            </div>
            <div class="cs-build-row">
              <span class="cs-build-label">{{ ui.csm_layout_users_online }}</span>
              <span class="cs-build-value">{{ onlineUser.current }} / {{ onlineUser.max }}</span>
            </div>
          </div>
        </div>

      </div>
    </aside>
    <div class="control-sidebar-bg"></div>

    <loading-box ref="myLB"></loading-box>
    <logout ref="logout"></logout>
    <change-lang ref="changeLang"></change-lang>

    <!-- Modal : Pop-up Call Center -->
    <modal ref="phoneModal">
      <template slot="header">
        <h3 class="text-center"><i class="fa fa-bell shake text-danger"></i> {{ ui.csm_layout_incoming_call }}</h3>
      </template>
      <template slot="body">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12">
            <div class="text-center">
              <h2><i class="ion ion-android-phone-portrait"></i> {{ ui.erp_tel }} : <span v-text="viewPhone"></span></h2>
              <h3 v-if="xt.isEmpty(viewData.customer_name)">{{ ui.csm_layout_no_customer_by_phone }}</h3>
              <template v-if="!xt.isEmpty(viewData.customer_name)">
                <h3 v-text="viewData.customer_name"></h3>
                <h5>{{ ui.csm_v2_project }} : [{{ viewData.pre_event }}] {{ viewData.pre_des }}</h5>
                <h5 v-text="viewData.address"></h5>
              </template>
            </div>
          </div>
        </div>
      </template>
      <template slot="footer">
        <div class="pull-left">
          <button class="btn btn-sm bg-olive" v-if="xt.isEmpty(viewData.customer) && !is_mango()"
                  @click="newCusByRing()">
            <i class="fas fa-user-plus"></i> {{ ui.erp_new_cust }}
          </button>
        </div>

        <button class="btn btn-sm bg-navy" @click="popupDocument()"><i class="fas fa-edit"></i> {{ ui.erp_create_document }}</button>
      </template>
    </modal>
    <!-- Modal Customer -->
    <modal ref="addCustomerModal" sheet-class="nc-modal">
      <template slot="header">
        <div class="modal-head">
          <div class="modal-head__icon"><i class="fas fa-user-plus"></i></div>
          <div class="modal-head__text">
            <div class="nc-head__kicker">Master Customer</div>
            <div class="modal-head__title">{{ ui.erp_new_cust }}</div>
          </div>
        </div>
      </template>
      <template slot="body">
        <div class="nc" :class="{ 'is-saved': customerRef.customer_code }">
          <aside class="nc__card">
            <div class="nc__card-body">
              <div class="nc__avatar">
                <span v-if="customerInitials">{{ customerInitials }}</span>
                <i class="fas fa-user" v-else></i>
              </div>
              <div class="nc__who">
                <div class="nc__name" :class="{ 'is-empty': !customerFullName }">{{ customerFullName || ui.erp_new_cust }}</div>
                <div class="nc__nick" v-if="customerData.nickname">“{{ customerData.nickname }}”</div>
              </div>
              <ul class="nc__lines">
                <li :class="{ 'is-empty': !customerData.tel }"><i class="fas fa-phone-alt"></i><span>{{ customerData.tel || '—' }}</span></li>
                <li :class="{ 'is-empty': !customerData.mail }"><i class="fas fa-envelope"></i><span>{{ customerData.mail || '—' }}</span></li>
              </ul>
            </div>
            <div class="nc__stub">
              <a href="#" class="nc__code" v-if="customerRef.customer_code" @click.prevent="openReqbyCustomer()">
                <i class="fas fa-check-circle nc__stamp"></i>
                <span>{{ customerRef.customer_code }}</span>
                <i class="fas fa-arrow-right nc__go"></i>
              </a>
              <span class="nc__code is-pending" v-else><i class="fas fa-hashtag"></i><span>— — — —</span></span>
              <p class="nc__stub-hint">{{ ui.csm_layout_customer_code_hint }}</p>
            </div>
          </aside>
          <div class="nc__form">
            <div class="nc__grid nc__grid--3">
              <label class="nc__field is-required">
                <span class="nc__label">{{ ui.csm_layout_firstname }}</span>
                <input type="text" class="form-control" v-model="customerData['first_name']" />
              </label>
              <label class="nc__field is-required">
                <span class="nc__label">{{ ui.csm_layout_lastname }}</span>
                <input type="text" class="form-control" v-model="customerData['last_name']" />
              </label>
              <label class="nc__field">
                <span class="nc__label">{{ ui.csm_layout_nickname }}</span>
                <input type="text" class="form-control" v-model="customerData['nickname']" />
              </label>
            </div>
            <div class="nc__grid nc__grid--2">
              <label class="nc__field">
                <span class="nc__label">{{ ui.erp_tel }}</span>
                <span class="nc__input">
                  <i class="fas fa-phone-alt"></i>
                  <input type="text" class="form-control" v-model="customerData['tel']" />
                </span>
                <span class="nc__hint">{{ ui.csm_layout_tel_example }}</span>
              </label>
              <label class="nc__field">
                <span class="nc__label">{{ ui.csm_v2_email }}</span>
                <span class="nc__input">
                  <i class="fas fa-envelope"></i>
                  <input type="text" class="form-control" v-model="customerData['mail']" />
                </span>
                <span class="nc__hint">{{ ui.csm_layout_email_example }}</span>
              </label>
            </div>
            <div class="nc__note">
              <span class="nc__note-icon"><i class="fas fa-lightbulb"></i></span>
              <div>
                <b>{{ ui.erp_option_3 }}</b>
                <p>{{ ui.csm_layout_note_master_customer }} <a href="#" @click.prevent="openMasCustomer()">Master Customer</a> {{ ui.csm_layout_note_suffix }}</p>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template slot="footer">
        <button class="btn btn-sm btn-success nc__save" @click="createCustomer()"><i class="fa fa-save"></i> {{ ui.csm_v2_save }}</button>
      </template>
    </modal>

    <modal ref="revProdModal" sheet-class="rp-modal">
      <template slot="header">
        <div class="modal-head">
          <div class="modal-head__icon"><i class="fas fa-code-branch"></i></div>
          <div class="modal-head__text">
            <div class="rp-head__kicker">{{ ui.csm_layout_rev_prod_kicker }}</div>
            <div class="modal-head__title">
              <span>{{ ui.csm_layout_rev_prod_title }}</span>
              <span class="rp-head__pill">{{ (ui.csm_layout_rev_prod_items || '').replace('{0}', notiRevProd.length) }}</span>
            </div>
            <div class="modal-head__sub">{{ ui.csm_layout_rev_prod_hint }}</div>
          </div>
        </div>
      </template>
      <template slot="body">
        <div class="rp">
          <div class="rp__bar" v-if="notiRevProd.length">
            <span>{{ ui.csm_layout_rev_prod_list_label }}</span>
            <span class="rp__sort"><i class="far fa-clock"></i> {{ ui.csm_layout_rev_prod_sorted }}</span>
          </div>
          <template v-for="g in revProdGroups">
          <div class="rp__group" v-if="g.status" :key="'g' + g.status">
            <span class="rp__group-dot" :class="'is-' + g.status"></span>
            <span class="rp__group-name">{{ g.name }}</span>
            <span class="rp__group-count">{{ g.items.length }}</span>
          </div>
          <ul class="rp__list" :key="'l' + g.status">
            <li class="rp__row" v-for="(x, idx) in g.items" :key="idx"
                :class="{ 'is-done': !xt.isEmpty(x.revision_prod) }" :style="{ '--i': idx }">
              <span class="rp__rail"></span>
              <div class="rp__main">
                <div class="rp__meta">
                  <button type="button" class="rp__copy" :class="{ 'is-copied': x._docCopied }"
                          :title="x._docCopied ? ui.csm_trn_copied : ui.csm_trn_copy" @click="copyJobNo(x)">
                    <i :class="x._docCopied ? 'fas fa-check' : 'far fa-copy'"></i>
                  </button>
                  <a class="rp__doc" :href="baseUrl + 'page/transaction/v_csm_trn_001/?job_no=' + x.job_no" target="_blank">{{ x.job_no }}</a>
                  <span class="rp__item">#{{ x.itemno }}</span>
                  <span class="rp__due" :class="revProdOverdue(x) > 0 ? 'is-late' : ''">
                    <i class="far fa-calendar-times" v-if="revProdOverdue(x) > 0"></i>
                    <i class="far fa-calendar" v-else></i>
                    <template v-if="revProdOverdue(x) > 0">{{ ui.csm_layout_rev_prod_overdue.replace('{0}', revProdOverdue(x)) }}</template>
                    <template v-else>{{ x.due_date | date('DD/MM/YYYY') }}</template>
                  </span>
                </div>
                <p class="rp__subject" :title="x.subject">{{ x.subject }}</p>
              </div>
              <div class="rp__flow">
                <button type="button" class="rp__uat" :class="{ 'is-copied': x._copied }"
                        :title="ui.csm_layout_rev_prod_copy" @click="copyUatToProd(x)">
                  <span class="rp__tag">UAT</span>
                  <span class="rp__code">{{ x.revision || '—' }}</span>
                </button>
                <i class="fas fa-arrow-right rp__arrow"></i>
                <label class="rp__prod">
                  <span class="rp__tag">PROD REVISION</span>
                  <input type="text" v-model.trim="x.revision_prod" :placeholder="ui.csm_trn_revision_prod_ph"
                         @keypress="numericOnly" maxlength="28" />
                  <i class="fas fa-check rp__ok"></i>
                </label>
              </div>
            </li>
          </ul>
          </template>
          <div class="rp__empty" v-if="!notiRevProd.length">
            <i class="far fa-check-circle"></i>
            <span>{{ ui.erp_no_data }}</span>
          </div>
        </div>
      </template>
      <template slot="footer">
        <div class="rp__foot">
          <div class="rp__status">
            <span class="rp__ring" :class="{ 'is-on': revProdFilled > 0 }" :style="{ '--p': revProdPercent + '%' }">
              <i class="fas fa-check"></i>
            </span>
            <span class="rp__status-text">
              <b>{{ (ui.csm_layout_rev_prod_ready || '').replace('{0}', revProdFilled).replace('{1}', notiRevProd.length) }}</b>
              <small>{{ ui.csm_layout_rev_prod_save_note }}</small>
            </span>
          </div>
          <div class="rp__actions">
            <button type="button" class="rp__btn rp__btn--ghost" @click="$refs.revProdModal.closeModal()">
              {{ ui.csm_layout_rev_prod_later }}
            </button>
            <button type="button" class="rp__btn rp__btn--save" :disabled="!revProdFilled" @click="saveRevisionProd()">
              <i class="fa fa-save"></i> {{ ui.csm_v2_save }}
            </button>
          </div>
        </div>
      </template>
    </modal>

    <div class="phone" v-show="auth.extension">
      <a href="#" @click.prevent="$refs.phoneModal.openModal()">
        <div class="quick-alo-ph-circle"></div>
        <div class="quick-alo-ph-circle-fill"></div>
        <div class="quick-alo-ph-img-circle"></div>
      </a>
    </div>

    <!-- Sidenav : nav-content slot -->
    <transition name="re-snav-fade">
      <div v-if="showNavContent"
           @click.self="closeNav()"
           class="re-snav-backdrop"></div>
    </transition>
    <transition name="re-snav-slide">
      <div v-if="showNavContent" class="re-snav-panel">
        <div class="re-snav-header">
          <span class="re-snav-title">{{ ui.csm_layout_more_menu }}</span>
          <button @click="closeNav()" class="re-snav-close"><i class="fa fa-times"></i></button>
        </div>
        <div class="re-snav-divider"></div>
        <div class="re-snav-body">
          <slot name="nav-content"></slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import loadingBox from '../Center/loading-box.vue'
  import logout from '../Center/logout.vue'
  import changeLang from '../Center/change-language.vue'
  import sideMenu from './menu.vue'
  import { BroadcastChannel, createLeaderElection } from 'broadcast-channel'

  // SignalR instance และ session interval (module-level เพื่อไม่ให้ reactive)
  let xR = {}
  let docheck = null

  const channel = new BroadcastChannel('csm_channel')
  const elector = createLeaderElection(channel)

  const ACTIVITY_KEY = 'csm_last_activity'
  const ACTIVITY_SAVE_INTERVAL = 10000
  let lastActivitySaved = 0

  // รายชื่อ empno ที่มีสิทธิ์ Admin / SuperAdmin
  const ADMIN_LIST = [983, 154, 172, 202, 253, 324, 310, 223, 510, 384, 514, 495,517]
  const SUPER_ADMIN_LIST = [983, 253, 324, 223, 207, 121, 259, 510, 356, 357, 358, 476]
  const ADMIN_IT = [517]

  export default {
    components: { loadingBox, logout, changeLang, sideMenu },

    data() {
      return {
        year: moment().year(),
        pageTitle: '',
        showNavMore: false,
        auth: window.auth,
        ui: window.ui,
        appinfo: window.appinfo,
        dataServer: window.dataServer,
        onlineUser: {
          current: 0,
          max: 0,
          is_authen: false,
          right_s3: false
        },
        viewVersion: window.viewVersion,
        viewStatus: '',
        viewNotiDueDate: [],
        notiRevProd: [],
        notiTag: { assign: [], mention: [], count_assign: 0, count_mention: 0, mention_life_sec: 60 },
        notiComment: [],
        showToolsPanel: false,
        toolsPanelTimer: null,
        notiTagExpireId: null,
        notiTagPollId: null,
        notiTagLoadedAt: null,
        notiCommentLoadedAt: null,
        viewData: {},
        viewPhone: '',
        stateData: [],
        xt: $xt,
        baseUrl,
        customerData: {},
        customerRef: {},
        empsign: {},
        totalCSMLine: 0,
        isDarkMode: false,
        selectedMaincode: (window.auth || {}).maincode || '',
        companyList: [],
        isLoadingCompany: false,
        isLeader: false,
        showNavContent: false,
        lastActivityTime: Date.now(),
        presenceStatus: 'online',
        IDLE_THRESHOLD: 300, // 5 นาที (วินาที)
        AWAY_THRESHOLD: 900, // 15 นาที (วินาที)
        DUE_PREVIEW_ROWS: 4,
        heartbeatIntervalId: null,
        configNotiReady: false,
      }
    },

    watch: {
      configData() { this.initConfigNoti() },
    },

    computed: {
      configData() { return store.state.configData },
      revProdFilled() { return this.notiRevProd.filter(x => !$xt.isEmpty(x.revision_prod)).length },
      revProdPercent() { return this.notiRevProd.length ? Math.round(this.revProdFilled / this.notiRevProd.length * 100) : 0 },
      revProdSorted() {
        return this.notiRevProd.slice().sort((a, b) => {
          const da = moment(a.due_date), db = moment(b.due_date)
          if (!da.isValid()) return 1
          if (!db.isValid()) return -1
          return da - db
        })
      },
      revProdGroups() {
        const status = window.statusCodeData || []
        const order = status.map(s => s.id)
        const groups = []
        this.revProdSorted.forEach(x => {
          const key = x.status || ''
          let g = groups.find(y => y.status === key)
          if (!g) {
            g = { status: key, name: (status.find(s => s.id === key) || {}).name || key, items: [] }
            groups.push(g)
          }
          g.items.push(x)
        })
        return groups.sort((a, b) => order.indexOf(a.status) - order.indexOf(b.status))
      },
      customerInitials() {
        const first = s => (s || '').trim().replace(/^[เแโใไ]/, '').charAt(0)
        return (first(this.customerData.first_name) + first(this.customerData.last_name)).toUpperCase()
      },
      customerFullName() {
        return [this.customerData.first_name, this.customerData.last_name].filter(x => !$xt.isEmpty(x)).join(' ')
      },
      notiTagCount() { return (this.notiTag.count_assign || 0) + (this.notiTag.count_mention || 0) },
      notiTagReadLabel() {
        const unread = this.notiTag.count_mention || 0
        return unread > 0 ? (this.ui.csm_noti_unread_count || '').replace('{0}', unread) : this.ui.csm_noti_all_read
      },
      notiTagDayLabel() { return this.notiDayLabel((this.notiTag.assign || []).concat(this.notiTag.mention || [])) },
      notiTagUpdatedAgo() { return this.notiTagAgo(this.notiTagLoadedAt) },
      notiCommentReadLabel() { return (this.ui.csm_noti_unread_count || '').replace('{0}', this.notiComment.length) },
      notiCommentDayLabel() { return this.notiDayLabel(this.notiComment) },
      notiCommentUpdatedAgo() { return this.notiTagAgo(this.notiCommentLoadedAt) },
      notiDueDateSorted() {
        return (this.viewNotiDueDate || []).slice().sort((a, b) => {
          const da = moment(a.alr_duedate), db = moment(b.alr_duedate)
          if (!da.isValid()) return 1
          if (!db.isValid()) return -1
          return da - db
        })
      },
      notiDuePreviewCount() { return Math.min(this.DUE_PREVIEW_ROWS, this.viewNotiDueDate.length || 0) },
      notiCommentEnabled() {
        if (this.is_mango()) return true
        const cfg = this.configData.find(x => x.config_id === 'TRN000C')
        return cfg?.config_value === 'Y'
      },
      toolsGroups() {
        const u = this.ui
        const mango = this.is_mango()
        const groups = [
          {
            key: 'doc', color: '#E08A2E', icon: 'fas fa-wrench',
            text: u.csm_layout_document_settings, show: mango,
            items: [
              { code: 'DOC', icon: 'fas fa-file-signature', text: u.csm_layout_edit_document_dev, link: 'page/tools/v_csm_tools', show: (this.isSuperAdmin() && mango) || this.isAdminMG() },
              { code: 'RUN', icon: 'fas fa-hashtag', text: u.csm_layout_doc_running_form, link: 'page/tools/v_csm_doc_running', show: true },
              { code: 'ERP', icon: 'fas fa-sliders-h', text: u.csm_layout_software_erp_config, link: 'page/tools/v_csm_erp_config', show: true },
            ],
          },
          {
            key: 'it', color: '#6D5BD0', icon: 'fas fa-user-shield',
            text: u.csm_layout_for_it_mango, show: this.isDeveloper() && mango,
            items: [
              { code: 'EMP', icon: 'fas fa-users-cog', text: u.csm_layout_list_it_employee, link: 'page/tools/v_csm_employee', show: true },
              { code: 'PASS', icon: 'fas fa-key', text: u.csm_layout_create_passcode_dev, link: 'page/tools/v_csm_passcode', show: true },
              { code: 'DB', icon: 'fas fa-database', text: u.csm_layout_database_list, link: 'page/tools/v_csm_db_list', show: true },
              { code: 'MST', icon: 'fas fa-shield-alt', text: u.csm_layout_view_master_passcode, link: 'page/master/', show: true },
            ],
          },
          {
            key: 'admin', color: '#D6455D', icon: 'fas fa-user-secret',
            text: u.csm_menu_admin_only, show: this.isAdmin(),
            items: [
              { code: 'CHK', icon: 'fas fa-clipboard-check', text: u.csm_layout_checking_update_program, link: 'page/manual/v_csm_manual_list_admin', show: true },
            ],
          },
          {
            key: 'upd', color: '#2F6FB8', icon: 'fas fa-list',
            text: u.csm_layout_update_list_program, show: mango,
            items: [
              { code: 'UPD', icon: 'fas fa-list-ul', text: u.csm_layout_update_list_program, link: 'page/manual/v_csm_manual_list_v2', show: true },
            ],
          },
          {
            key: 'log', color: '#1E9E7E', icon: 'fas fa-clipboard-list',
            text: u.csm_layout_logs_programs, show: mango,
            items: [
              { code: 'LOG', icon: 'fas fa-clipboard-list', text: u.csm_layout_logs_programs, link: 'page/custommango/v_csm_logs_program', show: true },
              { code: 'RPT', icon: 'fas fa-chart-bar', text: u.csm_layout_rpt_update_list_task, link: 'page/custommango/v_csm_logs_report', show: true },
            ],
          },
        ]
        return groups
          .filter(g => g.show)
          .map(g => Object.assign({}, g, { items: g.items.filter(x => x.show) }))
          .filter(g => g.items.length > 0)
      },
    },

    // โหลด store ทุกตัวพร้อมกันก่อน component render
    async created() {
      await Promise.all([
        this.$store.dispatch('findConnection'),
        this.$store.dispatch('findRequest'),
        this.$store.dispatch('findPriority'),
        this.$store.dispatch('findService'),
        this.$store.dispatch('findServiceBug'),
        this.$store.dispatch('findConfig'),
        this.$store.dispatch('findCodeConfig'),
        this.$store.dispatch('findCompany'),
      ])
    },

    async mounted() {
      // ตั้งค่า Dark Mode จาก localStorage
      if (localStorage.getItem('mango_dark_mode') === '1') {
        this.isDarkMode = true
        document.body.classList.add('dark-mode')
      }

      // รับ broadcast จาก tab อื่น
      channel.onmessage = async (msg) => {
        try {
          const data = this.parseBroadcastMessage(msg)
          if (data) await this.handleBroadcastAction(data)
        } catch (e) {
          console.warn('Invalid broadcast message:', e)
        }
      }

const activityHandler = () => {
    const now = Date.now();
    this.lastActivityTime = now;
    if (now - lastActivitySaved < ACTIVITY_SAVE_INTERVAL) return;
    lastActivitySaved = now;
    try { localStorage.setItem(ACTIVITY_KEY, String(now)) } catch (e) { }
  };
  ['mousemove', 'keydown', 'click', 'wheel', 'touchstart'].forEach(e => document.addEventListener(e, activityHandler, { passive: true }));
  document.addEventListener('scroll', activityHandler, { capture: true, passive: true });
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') activityHandler();
  });


      this.initSignalR()
      this.loadCompanyByUserID()
      this.loadingBox = this.$refs.myLB
      this.$refs.phoneModal.setSize('modal-lg')
      this.$refs.addCustomerModal.setSize('modal-lg')
      this.$refs.revProdModal.setSize('modal-lg')

      // คืนค่า viewStatus จาก localStorage
      this.viewStatus = localStorage.getItem('viewStatus') || ''

      // โหลด notification และ CSM line พร้อมกัน
      this.loadNotiDueDate()
      this.loadCSM_Line()
      this.initConfigNoti()

      elector.awaitLeadership().then(() => {
        console.log('This tab is now leader.');
        this.isLeader = true;
        this.startLeaderTasks();
      });

      if (!$xt.isEmpty(this.auth.extension)) {
        this.loadState()
      }

      this.$nextTick(() => $(window).trigger('resize'))
    },

    beforeDestroy() {
      if (this.notiTagPollId) clearInterval(this.notiTagPollId)
      if (this.notiTagExpireId) clearTimeout(this.notiTagExpireId)
      if (this.toolsPanelTimer) clearTimeout(this.toolsPanelTimer)
      window.removeEventListener('storage', this.onNotiTagStorage)
      this.$root.$off('CSM_NOTI_REFRESH', this.loadNotiComment)
    },

    methods: {
      // ─── UI ──────────────────────────────────────────────────────────────────
            changeLanguage() {
              this.$refs.changeLang.openModal()
            },
            // ─── SignalR ──────────────────────────────────────────────────────────────
            initSignalR() {
              const cfn = {
                 sessionResult: (resp) => {
                  this.$set(this, 'onlineUser', {
                    current: resp.count,
                    max: resp.max,
                    is_authen: resp.is_authen
                  })
                },
                popUp: (resp, phone) => {
                  this.viewData = JSON.parse(resp) || {}
                  this.viewPhone = phone
                  this.$refs.phoneModal.openModal()
                },
                notifyCSM: (msg, status) => {
                  const map = { W: 'warning', R: 'error', S: 'success' }
                  const fn = map[status] || 'info'
                  $notify[fn](msg, '', { timeOut: 15000, extendedTimeOut: 5000 })
                  this.loadNotiTag()
                },
                reloadNotiComment: () => { this.loadNotiComment() },
                reloadCallHistory: () => { try { this.$parent.loadHistoryService() } catch (e) { } },
                reloadCallCenter: () => { try { this.$parent.loadCustomerService() } catch (e) { } },
                reloadTransaction: () => { try { this.$parent.loadTotal(); this.$parent.loadData() } catch (e) { } },
                AiChatChunk: (data) => { this.$root.$emit('AiChatChunk', data) },
                AiChatDone: (data) => { this.$root.$emit('AiChatDone', data) },
                AiChatError: (data) => { this.$root.$emit('AiChatError', data) },
              }

              xR = window.signalR(cfn, () => {
                const token = localStorage.getItem('mango_auth') || ''
                xR.reHub.server.joinUserChannel(token)
                if (xR.hubProxy?.isConnectionOwner()) {
                  if (docheck) clearInterval(docheck)
                  const checkSession = () => xR.reHub.server.userOnlineCheck(token)
                  checkSession()
                  docheck = setInterval(checkSession, 60000)
                }
              })
            },
            // ─── Data Loaders ─────────────────────────────────────────────────────────
            async loadNotiDueDate() {
              const rsp = await $xt.getServer('CSM/Data/NotificationDocument')
              this.viewNotiDueDate = rsp.data
            },
            async loadNotiTag() {
              if (!this.is_mango()) return
              try {
                const rsp = await $xt.getServer('CSM/Data/CSM_Notify_ReadList')
                const d = rsp.data || {}
                this.$set(this, 'notiTag', {
                  assign: d.assign || [],
                  mention: d.mention || [],
                  count_assign: d.count_assign || 0,
                  count_mention: d.count_mention || 0,
                  mention_life_sec: d.mention_life_sec || 60
                })
                this.notiTagLoadedAt = new Date()
                this.scheduleNotiTagExpire()
              } catch (e) {
                console.warn('loadNotiTag failed:', e)
              }
            },
            // @ มีอายุ 60 วินาที — ตั้งเวลารีเฟรชตอนตัวที่เก่าสุดหมดอายุพอดี ไม่ต้องรอรอบ poll
            scheduleNotiTagExpire() {
              if (this.notiTagExpireId) {
                clearTimeout(this.notiTagExpireId)
                this.notiTagExpireId = null
              }
              if (!this.notiTag.mention.length) return

              const life = this.notiTag.mention_life_sec
              const left = this.notiTag.mention.map(x => life - ($xt.int(x.age_sec) || 0))
              const soonest = Math.min.apply(null, left)
              this.notiTagExpireId = setTimeout(() => this.loadNotiTag(), Math.max(1, soonest) * 1000 + 250)
            },
            async markAllNotiTagRead() {
              const ids = (this.notiTag.mention || []).map(x => x.notify_id).filter(x => !$xt.isEmpty(x))
              if (!ids.length) return
              try {
                await $xt.postServerJson('CSM/Data/CSM_Notify_MarkRead', { notify_ids: ids })
              } catch (e) {
                console.warn('markAllNotiTagRead failed:', e)
              }
              this.loadNotiTag()
            },
            closeNotiPanel(e) {
              $(e.target).closest('.dropdown').removeClass('open')
            },
            async markAllNotiCommentRead() {
              const rows = (this.notiComment || []).filter(x => !$xt.isEmpty(x.job_no))
              if (!rows.length) return
              try {
                await Promise.all(rows.map(x => $xt.postServerJson('CSM/Data/CSM_NotifyComment_MarkRead', { job_no: x.job_no, ref_itemno: x.ref_itemno })))
              } catch (e) {
                console.warn('markAllNotiCommentRead failed:', e)
              }
              this.loadNotiComment()
            },
            notiDayLabel(rows) {
              const dates = (rows || []).map(x => moment(x.add_dt)).filter(m => m.isValid()).sort((a, b) => b - a)
              if (!dates.length) return this.ui.csm_noti_today
              return dates[0].isSame(moment(), 'day') ? this.ui.csm_noti_today : dates[0].format('DD/MM/YYYY')
            },
            openToolsPanel() {
              clearTimeout(this.toolsPanelTimer)
              this.showToolsPanel = true
            },
            scheduleCloseToolsPanel() {
              clearTimeout(this.toolsPanelTimer)
              this.toolsPanelTimer = setTimeout(() => { this.showToolsPanel = false }, 250)
            },
            toggleToolsPanel() {
              clearTimeout(this.toolsPanelTimer)
              this.showToolsPanel = !this.showToolsPanel
            },
            async loadNotiComment() {
              if (!this.notiCommentEnabled) return
              try {
                const rsp = await $xt.getServer('CSM/Data/CSM_NotifyComment_ReadList')
                const d = rsp.data || {}
                this.$set(this, 'notiComment', d.comment || [])
                this.notiCommentLoadedAt = new Date()
              } catch (e) {
                console.warn('loadNotiComment failed:', e)
              }
            },
            onNotiTagStorage(e) {
              if (e && e.key === 'CSM_NOTI_REFRESH') {
                this.loadNotiTag()
                this.loadNotiComment()
              }
            },
            notiTagAgo(dt) {
              if ($xt.isEmpty(dt)) return ''
              const m = moment(dt)
              return m.isValid() ? m.fromNow() : ''
            },
            async openNotiTag(x) {
              if (x.notify_id && x.notify_type === 'M' && $xt.isEmpty(x.read_dt)) {
                try {
                  await $xt.postServerJson('CSM/Data/CSM_Notify_MarkRead', { notify_ids: [x.notify_id] })
                } catch (e) {
                  console.warn('markRead failed:', e)
                }
              }
              this.loadNotiTag()
              window.open(`${baseUrl}page/custommango/v_csm_dashboard_case/?docno=${x.job_no}`, '_blank')
            },
            async openNotiComment(x) {
              try {
                await $xt.postServerJson('CSM/Data/CSM_NotifyComment_MarkRead', { job_no: x.job_no, ref_itemno: x.ref_itemno })
              } catch (e) {
                console.warn('markCommentRead failed:', e)
              }
              this.loadNotiComment()
              window.open(`${baseUrl}page/transaction/v_csm_trn_001/?job_no=${x.job_no}&ref_itemno=${x.ref_itemno}&tab=comment`, '_blank')
            },
            // # created() ไม่ถูก await — mounted รันก่อน findConfig เสร็จ is_mango() จึงยังเป็น false ต้องรอ configData มาก่อน
            initConfigNoti() {
              if (this.configNotiReady || !(this.configData || []).length) return
              this.configNotiReady = true
              this.loadNotiRevProd()
              this.loadNotiTag()
              this.loadNotiComment()

              // # เคลียร์เมื่อคนอื่นส่งตรวจ/ปิดเคส จึงต้อง poll ไม่ใช่รอ push อย่างเดียว
              if (this.is_mango() || this.notiCommentEnabled) {
                this.notiTagPollId = setInterval(() => { this.loadNotiTag(); this.loadNotiComment() }, 60000)
                window.addEventListener('storage', this.onNotiTagStorage)
                this.$root.$on('CSM_NOTI_REFRESH', this.loadNotiComment)
              }
            },
            async loadNotiRevProd() {
              if (!this.is_mango()) return
              const rsp = await $xt.getServer('CSM/Data/NotificationRevisionProd')
              this.notiRevProd = (rsp.data || []).map(x => Object.assign({}, x, { revision_prod: '', _copied: false, _docCopied: false }))
            },
            openRevProdModal() {
              this.$refs.revProdModal.openModal()
            },
            revProdOverdue(x) {
              if (!x.due_date) return 0
              const due = moment(x.due_date).startOf('day')
              if (!due.isValid()) return 0
              return Math.max(0, moment().startOf('day').diff(due, 'days'))
            },
            copyUatToProd(x) {
              if ($xt.isEmpty(x.revision)) return
              x.revision_prod = String(x.revision)
              x._copied = true
              setTimeout(() => { x._copied = false }, 600)
            },
            async copyJobNo(x) {
              const text = String(x.job_no || '')
              if (!text) return
              try {
                if (navigator.clipboard && window.isSecureContext) {
                  await navigator.clipboard.writeText(text)
                } else {
                  const ta = document.createElement('textarea')
                  ta.value = text
                  ta.setAttribute('readonly', '')
                  ta.style.position = 'fixed'
                  ta.style.opacity = '0'
                  document.body.appendChild(ta)
                  ta.select()
                  document.execCommand('copy')
                  document.body.removeChild(ta)
                }
                x._docCopied = true
                setTimeout(() => { x._docCopied = false }, 1200)
                $notify.success(`${this.ui.csm_trn_copied || 'คัดลอกแล้ว'} : ${text}`)
              } catch (ex) {
                $notify.error(String(ex || 'Copy failed'))
              }
            },
            numericOnly(evt) {
              evt = (evt) ? evt : window.event
              var charCode = (evt.which) ? evt.which : evt.keyCode
              if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46 && charCode !== 45) {
                evt.preventDefault()
              } else {
                return true
              }
            },
            async saveRevisionProd() {
              try {
                const detail = this.notiRevProd.filter(x => !$xt.isEmpty(x.revision_prod))
                if (!detail.length) {
                  $notify.warning(this.ui.csm_layout_rev_prod_req)
                  return
                }
                const rsp = await $xt.postServerJson('csm/data/CSM_SaveRevisionProd', { detail })
                if (!rsp.success) throw rsp.error
                $notify.success(this.ui.alert_save_success)
                await this.loadNotiRevProd()
                if (!this.notiRevProd.length) this.$refs.revProdModal.closeModal()
              } catch (ex) {
                $msg.alert('', ex.toString(), 'danger')
              }
            },
            async loadState() {
              const rsp = await $xt.getServer('csm/config/State_ReadList')
              this.$set(this, 'stateData', rsp.data.data_rows.filter(x => !['11', '12'].includes(x.state_code)))
            },
            async setState() {
              const rsp = await $xt.getServer(`CSM/Data/ChangeState?state_code=${this.viewStatus}`)
              if (rsp.success) {
                localStorage.setItem('viewStatus', rsp.data)
              } else {
                $msg.alert(this.ui.erp_error, rsp.error, 'danger')
              }
            },
            async loadEmpSign() {
              const rsp = await $xt.getServer('CSM/Center/GetEmpSign')
              this.empsign = rsp.data
            },
            async loadCSM_Line() {
              const rsp = await $xt.getServer('CSM/Data/CSM_Line_ReadListX_Count?status=N')
              this.$set(this, 'totalCSMLine', rsp.total)
            },
            // ─── Document Popup ───────────────────────────────────────────────────────
            popupDocument() {
              if (!Object.keys(this.viewData).length) {
                this.viewData.phone = this.viewPhone
              }
              localStorage.setItem('Customer-Popup-CSM', JSON.stringify(this.viewData))
              window.open(`${this.baseUrl}page/Transaction/v_csm_trn_001/`, '_blank')
            },
            // ─── Customer Methods ─────────────────────────────────────────────────────
            openCustomer() {
              this.$refs.addCustomerModal.openModal()
              this.customerData = {}
              this.customerRef = {}
            },
            async createCustomer() {
              try {
                if ($xt.isEmpty(this.customerData.first_name) || $xt.isEmpty(this.customerData.last_name)) {
                  $notify.warning(this.ui.csm_layout_req_name)
                  return
                }
                const rsp = await $xt.postServerJson('csm/data/CreateCustomer', { header: this.customerData })
                if (!rsp.success) throw rsp.error
                this.customerRef = rsp.data
                $notify.success(this.ui.alert_save_success)
              } catch (ex) {
                $msg.alert('', ex.toString(), 'danger')
              }
            },
            openReqbyCustomer() {
              localStorage.setItem('X-Customer-CSM', JSON.stringify(this.customerRef))
              window.open(`${this.baseUrl}page/Transaction/v_csm_trn_001/`, '_blank')
            },
            openMasCustomer() {
              localStorage.setItem('X-Master-Customer', JSON.stringify(this.customerRef))
              window.open(`${this.baseUrl}page/Customer/v_csm_cus_001/`, '_blank')
            },
            newCusByRing() {
              this.$refs.phoneModal.closeModal()
              this.$refs.addCustomerModal.openModal()
              this.$set(this.customerData, 'tel', this.viewPhone)
            },
            // ─── Permission Checks ────────────────────────────────────────────────────
            /** ตรวจสอบว่าเป็น Mango company หรือไม่ */
            is_mango() {
              const cfg = this.configData.find(x => x.config_id === 'TRN0001')
              return cfg?.config_value === 'Y'
            },
            /** ตรวจสอบว่าเป็น IT Developer */
            isDeveloper() {
              return auth.empcode.substring(0, 2) === 'IT'
            },
            /** ตรวจสอบว่าเป็น Admin ของ Mango */
            isAdminMG() {
              return auth.empcode.substring(0, 7) === 'ADMINMG'
            },
            /** ตรวจสอบสิทธิ์ Admin */
            isAdmin() {
              return ADMIN_LIST.includes(this.auth.empno)
            },
              isAdminIT() {
              return ADMIN_IT.includes(this.auth.empno)
            },
            /** ตรวจสอบสิทธิ์ Super Admin */
            isSuperAdmin() {
              return SUPER_ADMIN_LIST.includes(this.auth.empno)
            },
            /** ตรวจสอบว่ามีสิทธิ์ Approve */
            isApprove() {
              return this.empsign.some(x => x.empcode === auth.empcode)
            },
            // ─── Dark Mode ────────────────────────────────────────────────────────────
            toggleDarkMode() {
              this.isDarkMode = !this.isDarkMode
              document.body.classList.toggle('dark-mode', this.isDarkMode)
              if (this.isDarkMode) localStorage.setItem('mango_dark_mode', '1')
              else localStorage.removeItem('mango_dark_mode')
              this.sendBroadcast('dark_mode', { enabled: this.isDarkMode })
            },
            // ─── Broadcast ────────────────────────────────────────────────────────────
            sendBroadcast(action, data = null) {
              try {
                channel.postMessage(JSON.stringify({ action, data, timestamp: Date.now() }))
              } catch (e) {
                console.error('Broadcast failed:', e)
              }
            },
            parseBroadcastMessage(msg) {
              try {
                return typeof msg === 'string' ? JSON.parse(msg) : msg
              } catch (e) {
                return null
              }
            },
            async handleBroadcastAction({ action, data }) {
              if (action === 'dark_mode') {
                const enabled = data?.enabled ?? false
                this.isDarkMode = enabled
                document.body.classList.toggle('dark-mode', enabled)
                if (enabled) localStorage.setItem('mango_dark_mode', '1')
                else localStorage.removeItem('mango_dark_mode')
              }
            },
          async loadCompanyByUserID() {
          try {
            this.$set(this, 'isLoadingCompany', true)
            let resp = await $xt.getServer(`api/public/LoginCompaniesByUserID?userid=${encodeURIComponent(this.auth.userid)}`)
            if (!resp.success) throw resp.error
            let list = $linq(resp.data).select(x => ({ id: x.maincode, text: x.mainname })).toArray()
            this.$set(this, 'companyList', list)
            this.$set(this, 'selectedMaincode', this.auth.maincode)
          } catch (ex) {
            $msg.alert(this.ui.csm_v2_warning, ex, 'warning')
          } finally {
            this.$set(this, 'isLoadingCompany', false)
          }
        },
      async changeCompany() {
        if (!this.selectedMaincode) {
          $msg.alert(this.ui.erp_error, this.ui.csm_layout_req_company, 'warning')
          return
        }
        if (this.selectedMaincode === this.auth.maincode) {
          $msg.alert(this.ui.erp_info, this.ui.csm_layout_already_in_company, 'info')
          return
        }
        try {
          this.$set(this, 'isLoadingCompany', true)
          const payload = {
            maincode: this.selectedMaincode,
            session_id: this.auth.session_id
          }
          const resp = await $xt.postServerJson('API/UserOnline/UserChangeCompany', payload)
          if (!resp.success) throw resp.error
          localStorage.setItem('mango_auth', resp.token)
          this.sendBroadcast('reload')
          window.location.reload()
        }
        catch (ex) {
          $msg.alert(this.ui.erp_error, ex, 'danger')
        }
        finally {
          this.$set(this, 'isLoadingCompany', false)
        }
      },
    async checkUserOnline() {
        if (!window.navigator.onLine) {
          $notify.error(this.ui.csm_layout_no_connection)
          return
        }

        try {
          const payload = {
            maincode: this.auth.maincode,
            session_id: this.auth.session_id
          }
          const resp = await $xt.postServerJson('API/UserOnline/UserAuthentication', payload)

          this.$set(this, 'onlineUser', {
            current: resp.useronline.count,
            max: resp.useronline.max,
            right_s3: resp.right_log_s3
          })
          this.$set(this, 'expire_user', {
            check_expire: resp.check_expire,
            start_expire: moment(resp.expire_dt, 'YYYY-MM-DD').add(-3, 'days'),
            end_expire: moment(resp.expire_dt, 'YYYY-MM-DD')
          })

          if (!resp.auth_status) await this.messageLogout()
        } catch (ex) {
          await $msg.alert(this.ui.csm_v2_warning, this.ui.csm_layout_session_expired, 'warning')
          await this.messageLogout()
        }
      },
      getLastActivityTime() {
    let shared = 0
    try { shared = Number(localStorage.getItem(ACTIVITY_KEY)) || 0 } catch (e) { }
    return Math.max(this.lastActivityTime, shared)
  },
      updatePresenceStatus() {
    const idle = Math.floor((Date.now() - this.getLastActivityTime()) / 1000)
    if (idle >= this.AWAY_THRESHOLD) this.presenceStatus = 'away'
    else if (idle >= this.IDLE_THRESHOLD) this.presenceStatus = 'idle'
    else this.presenceStatus = 'online'
  },
  // ฟังก์ชันหลักที่ Leader จะใช้ยิง API
  async checkUserOnline2() {
    if (!window.navigator.onLine) return;
    try {
      this.updatePresenceStatus();
      const idleSeconds = Math.floor((Date.now() - this.getLastActivityTime()) / 1000);
      const noTouch = this.presenceStatus !== 'online';

      const resp = await $xt.postServerJson('API/UserOnline/UserAuthentication', {
        maincode: this.auth.maincode,
        session_id: this.auth.session_id,
        idle_seconds: idleSeconds,
        presence_status: this.presenceStatus
      }, noTouch ? { 'X-Mango-No-Touch': 'Y' } : null);

      const sessionData = {
        onlineUser: {
          current: resp.useronline.count,
          max: resp.useronline.max,
        },
        presenceStatus: this.presenceStatus
      };

      this.$set(this, 'onlineUser', sessionData.onlineUser);
      this.sendBroadcast('update', sessionData); // ส่งบอก Tab อื่นๆ

      if (!resp.auth_status) {
        this.sendBroadcast('logout');
        window.location.reload();
      }
    } catch (ex) { console.error(ex); }
  },
  // ฟังก์ชันเริ่มงานของ Leader
  async startLeaderTasks() {
    while (this.isLeader) {
      await this.checkUserOnline2();
      await $xt.sleep(20000); // เช็คทุก 20 วินาที
    }
  },
  // ปรับปรุง handleBroadcastAction ให้รองรับการ update ข้อมูล
  async handleBroadcastAction({ action, data }) {
    if (action === 'update') {
      if (data.onlineUser) this.$set(this, 'onlineUser', data.onlineUser);
      if (data.presenceStatus) this.presenceStatus = data.presenceStatus;
    }
    if (action === 'logout') window.location.reload();
    // ... dark_mode logic เดิม ...
  },
  openNav() { this.showNavContent = true },
  closeNav() { this.showNavContent = false },

    },
  }
</script>

<style scoped>
  .rn-content-wrapper {
    padding-top: 50px !important;
    padding-bottom: 52px !important;
  }

  .content-body {
    overflow-x: hidden;
    height: calc(100vh - 112px);
    overflow-y: auto;
  }

  @media (max-width: 991px) {
    .rn-content-wrapper {
      padding-left: 0 !important;
      padding-right: 0 !important;
      padding-bottom: 0 !important;
    }
    .content-body {
      height: calc(100vh - 60px);
    }
    body.sidebar-mini.sidebar-collapse .main-sidebar {
      -webkit-transform: translate(-100%, 0) !important;
      transform: translate(-100%, 0) !important;
    }
  }

  .main-footer {
    position: fixed !important;
    bottom: 0; left: 0; right: 0;
    z-index: 820;
  }

  /* ── Header : Overflow Menu ── */
  .rn-more { display: none; }

  .rn-nav-backdrop {
    position: fixed;
    top: 0; right: 0; bottom: 0; left: 0;
    z-index: 1028;
    background: rgba(2, 35, 78, .28);
  }

  @media (max-width: 991px) {
    .rn-more { display: block; }
    .main-header .navbar-custom-menu > .nav.navbar-nav > .rn-more > a > i {
      background: rgba(2, 35, 78, .09) !important;
      color: #02234e !important;
    }
    .main-header .navbar-custom-menu > .nav.navbar-nav > .rn-more > a:hover > i {
      background: rgba(2, 35, 78, .17) !important;
      color: #02234e !important;
      box-shadow: none !important;
    }
    .main-header .navbar-custom-menu > .nav.navbar-nav > .rn-more > a.rn-more--on > i {
      background: #02234e !important;
      color: #fff !important;
      box-shadow: 0 2px 8px rgba(2, 35, 78, .35) !important;
    }

    .navbar-custom-menu > .rn-nav-overflow {
      display: none;
      position: absolute;
      top: 50px;
      right: 6px;
      left: auto;
      float: none !important;
      z-index: 1029;
      width: 302px;
      max-width: calc(100vw - 12px);
      max-height: calc(100vh - 66px);
      overflow-y: auto;
      margin: 0 !important;
      padding: 6px !important;
      border-radius: 14px;
      background: #fff;
      box-shadow: 0 20px 46px -18px rgba(2, 35, 78, .45), 0 4px 14px rgba(2, 35, 78, .10);
    }
    .navbar-custom-menu > .rn-nav-overflow.rn-open { display: block; }

    .rn-nav-overflow > li {
      display: block !important;
      position: static !important;
      float: none !important;
      margin: 0 !important;
    }
    .rn-nav-overflow > li > a {
      display: flex !important;
      align-items: center;
      gap: 9px;
      padding: 9px 10px !important;
      border-radius: 9px;
      color: #24344d !important;
      font-size: 13px;
      font-weight: 500;
      white-space: normal !important;
    }
    .rn-nav-overflow > li > a:hover,
    .rn-nav-overflow > li > a:focus {
      background: #eff4fb !important;
      color: #02234e !important;
    }
    .rn-nav-overflow > li > a > .caret { display: none !important; }
    .rn-nav-overflow > li > select.form-control {
      width: 100% !important;
      margin: 4px 0 6px;
    }

    .rn-nav-overflow .dropdown-menu {
      display: block !important;
      position: static !important;
      float: none !important;
      width: auto !important;
      min-width: 0 !important;
      margin: 0 0 2px !important;
      padding: 0 0 0 15px !important;
      border: 0 !important;
      border-radius: 0 !important;
      background: transparent !important;
      box-shadow: none !important;
    }
    .rn-nav-overflow .dropdown-menu > li > a {
      padding: 7px 10px !important;
      border-radius: 8px;
      color: #4a5b74 !important;
      font-size: 12.5px;
      white-space: normal !important;
    }
    .rn-nav-overflow .dropdown-menu > li > a:hover,
    .rn-nav-overflow .dropdown-menu > li > a:focus {
      background: #eff4fb !important;
      color: #02234e !important;
    }
  }

  /* ── Header : Page Title ── */
  .rn-page-title {
    display: inline-block;
    max-width: calc(100vw - 300px);
    overflow: hidden;
    vertical-align: middle;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  @media (max-width: 991px) {
    .main-header .navbar .sidebar-toggle {
      min-width: 66px;
      padding-top: 15px !important;
      padding-left: 20px !important;
      padding-right: 20px !important;
      text-align: center;
    }
    .navbar-custom-menu {
      position: absolute;
      top: 0;
      right: 0;
    }
    .navbar-custom-menu > .navbar-nav > li > a {
      padding-left: 12px !important;
      padding-right: 12px !important;
    }
  }

  @media (max-width: 480px) {
    .navbar-custom-menu > .navbar-nav > li > a {
      padding-left: 10px !important;
      padding-right: 10px !important;
    }
    .navbar-nav > .rn-noti > .rn-noti__panel {
      width: calc(100vw - 16px) !important;
      max-width: 388px !important;
    }
  }

  /* ── Sidebar : User Panel ── */
  .skin-black .user-panel {
    display: flex !important;
    align-items: center !important;
    gap: 11px !important;
    padding: 13px 12px !important;
    border-bottom: 1px solid rgba(255, 255, 255, .10) !important;
  }
  .skin-black .user-panel::before,
  .skin-black .user-panel::after {
    display: none !important;
  }

  .skin-black .user-panel > .image {
    position: relative;
    flex: 0 0 auto !important;
    float: none !important;
    width: 38px;
    height: 38px;
    padding: 2px;
    border-radius: 50%;
    background: linear-gradient(135deg, #4f9bf0, #1c56aa 55%, #14b8a6);
    box-shadow: 0 3px 10px rgba(28, 86, 170, .45);
  }
  .skin-black .user-panel > .image > img {
    display: block;
    width: 100% !important;
    max-width: none !important;
    height: 100% !important;
    border-radius: 50%;
    object-fit: cover;
    background: #02234e;
  }

  .skin-black .user-panel > .info {
    position: static !important;
    left: auto !important;
    flex: 1 1 auto !important;
    min-width: 0 !important;
    padding: 0 !important;
    line-height: 1.25 !important;
    white-space: normal !important;
  }
  .skin-black .user-panel > .info > p {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin: 0 0 5px !important;
    color: #fff !important;
    font-size: 13px !important;
    font-weight: 600 !important;
    line-height: 1.3 !important;
    word-break: break-word;
  }
  .skin-black .user-panel > .info > a {
    display: inline-flex !important;
    align-items: center !important;
    gap: 5px !important;
    margin: 0 !important;
    padding: 2px 8px 2px 6px !important;
    border: 1px solid rgba(46, 204, 113, .28) !important;
    border-radius: 999px !important;
    background: rgba(46, 204, 113, .14) !important;
    color: #7ee2a8 !important;
    font-size: 10.5px !important;
    font-weight: 600 !important;
  }
  .skin-black .user-panel > .info > a > .fa {
    margin: 0 !important;
    color: #2ecc71 !important;
    font-size: 7px !important;
  }

  @media (min-width: 768px) {
    body.skin-black.sidebar-collapse .user-panel {
      padding-left: 6px !important;
      padding-right: 6px !important;
    }
  }

  /* ── Control Sidebar : Panel ── */
  .control-sidebar,
  .control-sidebar-bg {
    width: 272px !important;
    right: -272px !important;
  }
  .control-sidebar.control-sidebar-open,
  .control-sidebar.control-sidebar-open + .control-sidebar-bg {
    right: 0 !important;
  }

  .control-sidebar {
    overflow-x: hidden !important;
    background:
      radial-gradient(120% 60% at 82% 0%, rgba(47, 116, 216, .28), rgba(47, 116, 216, 0) 60%),
      radial-gradient(90% 45% at 8% 2%, rgba(20, 184, 166, .14), rgba(20, 184, 166, 0) 58%),
      #0f1929 !important;
    box-shadow: -18px 0 40px rgba(0, 0, 0, .38);
  }

  .control-sidebar::-webkit-scrollbar { width: 6px; }
  .control-sidebar::-webkit-scrollbar-track { background: transparent; }
  .control-sidebar::-webkit-scrollbar-thumb { border-radius: 3px; background: rgba(255, 255, 255, .14); }
  .control-sidebar::-webkit-scrollbar-thumb:hover { background: rgba(255, 255, 255, .24); }

  body.dark-mode .control-sidebar {
    background:
      radial-gradient(120% 60% at 82% 0%, rgba(47, 116, 216, .22), rgba(47, 116, 216, 0) 60%),
      radial-gradient(90% 45% at 8% 2%, rgba(20, 184, 166, .11), rgba(20, 184, 166, 0) 58%),
      #080f1b !important;
  }

  /* ── Control Sidebar Tabs ── */
  .cs-tabs {
    display: flex !important;
    gap: 4px;
    margin: 10px 12px 2px !important;
    padding: 3px !important;
    border: 0 !important;
    border-radius: 11px;
    background: rgba(255, 255, 255, .05) !important;
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, .35);
  }
  .cs-tabs > li {
    flex: 1;
    margin: 0 !important;
    background: transparent !important;
  }
  .cs-tabs > li > a {
    display: flex !important;
    align-items: center;
    justify-content: center;
    height: 30px;
    margin: 0 !important;
    padding: 0 !important;
    border: 0 !important;
    border-radius: 8px !important;
    background: transparent !important;
    color: rgba(255, 255, 255, .42) !important;
    font-size: 13px;
    transition: color .2s cubic-bezier(.4,0,.2,1), background .2s cubic-bezier(.4,0,.2,1), box-shadow .2s cubic-bezier(.4,0,.2,1);
  }
  .cs-tabs > li > a:hover {
    color: rgba(255, 255, 255, .78) !important;
    background: rgba(255, 255, 255, .06) !important;
  }
  .cs-tabs > li.active > a,
  .cs-tabs > li.active > a:focus,
  .cs-tabs > li.active > a:hover {
    border: 0 !important;
    color: #fff !important;
    background: linear-gradient(180deg, #2f74d8, #1c56aa) !important;
    box-shadow: 0 2px 8px rgba(28, 86, 170, .5), inset 0 1px 0 rgba(255, 255, 255, .22);
  }

  /* ── Control Sidebar: User Card ── */
  .cs-user-card {
    display: flex;
    align-items: center;
    gap: 11px;
    margin: 8px 12px 2px;
    padding: 12px;
    border: 1px solid rgba(255, 255, 255, .09);
    border-radius: 14px;
    background: linear-gradient(160deg, rgba(255, 255, 255, .09), rgba(255, 255, 255, .03));
    box-shadow: 0 6px 18px rgba(0, 0, 0, .28), inset 0 1px 0 rgba(255, 255, 255, .10);
  }
  .cs-avatar {
    position: relative;
    flex-shrink: 0;
    width: 42px;
    height: 42px;
    padding: 2px;
    border: 0;
    border-radius: 50%;
    background: linear-gradient(135deg, #4f9bf0, #1c56aa 55%, #14b8a6);
    box-shadow: 0 3px 10px rgba(28, 86, 170, .45);
  }
  .cs-avatar img {
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
    background: #0f1929;
  }
  .cs-user-info { flex: 1; min-width: 0; }
  .cs-user-name {
    color: #fff;
    font-size: 13px;
    font-weight: 600;
    line-height: 1.3;
    white-space: normal;
    word-break: break-word;
  }
  .cs-user-status {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    margin-top: 5px;
    padding: 2px 8px 2px 6px;
    border: 1px solid rgba(46, 204, 113, .28);
    border-radius: 999px;
    background: rgba(46, 204, 113, .14);
    color: #7ee2a8;
    font-size: 10.5px;
    font-weight: 600;
  }
  .cs-dot {
    position: relative;
    flex-shrink: 0;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #2ecc71;
  }
  .cs-dot::after {
    content: '';
    position: absolute;
    top: -3px; right: -3px; bottom: -3px; left: -3px;
    border-radius: 50%;
    border: 1px solid rgba(46, 204, 113, .55);
    animation: cs-ping 2.2s cubic-bezier(.4,0,.2,1) infinite;
  }

  @keyframes cs-ping {
    0%   { transform: scale(.7); opacity: .8; }
    70%  { transform: scale(1.9); opacity: 0; }
    100% { transform: scale(1.9); opacity: 0; }
  }

  /* ── Section Label ── */
  .cs-section-label {
    display: flex;
    align-items: center;
    gap: 7px;
    padding: 14px 14px 7px;
    color: rgba(255, 255, 255, .38);
    font-size: 9.5px;
    font-weight: 800;
    letter-spacing: 1.2px;
    text-transform: uppercase;
  }
  .cs-section-label::after {
    content: '';
    flex: 1;
    height: 1px;
    background: linear-gradient(90deg, rgba(255, 255, 255, .12), rgba(255, 255, 255, 0));
  }

  /* ── Change Company Card ── */
  .control-sidebar-company-section {
    margin: 0 12px;
    padding: 11px;
    border: 1px solid rgba(255, 255, 255, .07);
    border-radius: 13px;
    background: rgba(0, 0, 0, .24);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .05);
  }
  .control-sidebar-company-section .btn-primary {
    height: 32px;
    border: 0 !important;
    border-radius: 9px !important;
    background: linear-gradient(180deg, #2f74d8, #1c56aa) !important;
    box-shadow: 0 3px 10px rgba(28, 86, 170, .42), inset 0 1px 0 rgba(255, 255, 255, .20);
    font-size: 12px;
    font-weight: 600;
    transition: transform .18s cubic-bezier(.4,0,.2,1), box-shadow .18s cubic-bezier(.4,0,.2,1);
  }
  .control-sidebar-company-section .btn-primary:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 6px 16px rgba(28, 86, 170, .5), inset 0 1px 0 rgba(255, 255, 255, .26);
  }
  .control-sidebar-company-section .btn-primary:disabled {
    opacity: .55;
    box-shadow: none;
  }

  /* ── Menu Items ── */
  .cs-menu { padding: 0 8px; margin: 0; list-style: none; }
  .cs-menu > li > a {
    position: relative;
    display: flex !important;
    align-items: center;
    gap: 10px;
    margin-bottom: 2px;
    padding: 7px 10px 7px 8px !important;
    border-radius: 10px;
    overflow: hidden;
    text-decoration: none;
    transition: background .18s cubic-bezier(.4,0,.2,1), transform .18s cubic-bezier(.4,0,.2,1);
  }
  .cs-menu > li > a::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    width: 2px;
    height: 0;
    border-radius: 0 2px 2px 0;
    background: linear-gradient(180deg, #4f9bf0, #14b8a6);
    transform: translateY(-50%);
    transition: height .22s cubic-bezier(.4,0,.2,1);
  }
  .cs-menu > li > a::after {
    content: '\f105';
    display: block;
    flex-shrink: 0;
    opacity: 0;
    color: rgba(255, 255, 255, .28);
    font-family: 'Font Awesome 5 Free';
    font-size: 11px;
    font-weight: 900;
    transform: translateX(-4px);
    transition: opacity .18s cubic-bezier(.4,0,.2,1), transform .18s cubic-bezier(.4,0,.2,1);
  }
  .cs-menu > li > a:hover {
    background: rgba(255, 255, 255, .075) !important;
    transform: translateX(2px);
  }
  .cs-menu > li > a:hover::before { height: 62%; }
  .cs-menu > li > a:hover::after { opacity: 1; transform: translateX(0); }
  .cs-menu .menu-info { flex: 1; min-width: 0; margin-left: 0 !important; }
  .cs-menu .menu-info h4 {
    margin: 0;
    color: rgba(255, 255, 255, .88);
    font-size: 12.5px;
    font-weight: 500;
    line-height: 1.3;
    white-space: normal;
    word-break: break-word;
  }
  .cs-menu .menu-info p {
    margin: 0;
    color: rgba(255, 255, 255, .45);
    font-size: 11px;
  }

  /* ── Icon pill ── */
  .cs-icon {
    position: relative;
    display: inline-flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 9px;
    color: #fff;
    font-size: 13px;
    box-shadow: 0 3px 9px rgba(0, 0, 0, .34), inset 0 1px 0 rgba(255, 255, 255, .20);
    transition: transform .18s cubic-bezier(.4,0,.2,1), box-shadow .18s cubic-bezier(.4,0,.2,1);
  }
  .cs-icon::after {
    content: '';
    position: absolute;
    top: 0; right: 0; bottom: 0; left: 0;
    border-radius: inherit;
    pointer-events: none;
    background: linear-gradient(160deg, rgba(255, 255, 255, .18), rgba(255, 255, 255, 0) 55%);
  }
  .cs-icon > i { position: relative; z-index: 1; }
  .cs-menu > li > a:hover .cs-icon {
    transform: scale(1.06);
    box-shadow: 0 5px 14px rgba(0, 0, 0, .42), inset 0 1px 0 rgba(255, 255, 255, .26);
  }

  /* ── Build Info ── */
  .cs-build-info {
    margin: 12px 12px 14px;
    padding: 9px 11px;
    border: 1px solid rgba(255, 255, 255, .06);
    border-radius: 12px;
    background: rgba(0, 0, 0, .30);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .04);
  }
  .cs-build-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    padding: 4px 0;
    border-bottom: 1px solid rgba(255, 255, 255, .055);
  }
  .cs-build-row:last-child { border-bottom: none; }
  .cs-build-label {
    color: rgba(255, 255, 255, .38);
    font-size: 9.5px;
    font-weight: 800;
    letter-spacing: .9px;
    text-transform: uppercase;
  }
  .cs-build-value {
    color: rgba(255, 255, 255, .82);
    font-family: 'JetBrains Mono', 'Consolas', monospace;
    font-size: 11px;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
  }

  /* ── Open reveal ── */
  .control-sidebar.control-sidebar-open .cs-user-card,
  .control-sidebar.control-sidebar-open .cs-section-label,
  .control-sidebar.control-sidebar-open .control-sidebar-company-section,
  .control-sidebar.control-sidebar-open .cs-menu > li,
  .control-sidebar.control-sidebar-open .cs-build-info {
    animation: cs-rise .42s cubic-bezier(.22,.9,.28,1) both;
  }

  @keyframes cs-rise {
    from { opacity: 0; transform: translateY(9px); }
    to   { opacity: 1; transform: none; }
  }

  .control-sidebar.control-sidebar-open .cs-user-card { animation-delay: .04s; }
  .control-sidebar.control-sidebar-open .cs-section-label { animation-delay: .08s; }
  .control-sidebar.control-sidebar-open .control-sidebar-company-section { animation-delay: .12s; }
  .control-sidebar.control-sidebar-open .cs-build-info { animation-delay: .24s; }
  .control-sidebar.control-sidebar-open .cs-menu > li:nth-child(1) { animation-delay: .14s; }
  .control-sidebar.control-sidebar-open .cs-menu > li:nth-child(2) { animation-delay: .175s; }
  .control-sidebar.control-sidebar-open .cs-menu > li:nth-child(3) { animation-delay: .21s; }
  .control-sidebar.control-sidebar-open .cs-menu > li:nth-child(4) { animation-delay: .245s; }
  .control-sidebar.control-sidebar-open .cs-menu > li:nth-child(5) { animation-delay: .28s; }
  .control-sidebar.control-sidebar-open .cs-menu > li:nth-child(n+6) { animation-delay: .315s; }

  @media (prefers-reduced-motion: reduce) {
    .cs-dot::after { animation: none; }
    .control-sidebar.control-sidebar-open .cs-user-card,
    .control-sidebar.control-sidebar-open .cs-section-label,
    .control-sidebar.control-sidebar-open .control-sidebar-company-section,
    .control-sidebar.control-sidebar-open .cs-menu > li,
    .control-sidebar.control-sidebar-open .cs-build-info {
      animation: none;
    }
    .cs-tabs > li > a,
    .cs-menu > li > a,
    .cs-menu > li > a::before,
    .cs-menu > li > a::after,
    .cs-icon,
    .control-sidebar-company-section .btn-primary {
      transition: none;
    }
  }

  .quick-alo-phone .quick-alo-show {
    visibility: visible;
  }

  .quick-alo-phone {
    position: fixed;
    visibility: hidden;
    background-color: transparent;
    height: 200px;
    width: 82px;
    height: 64px;
    right: 150px;
    top: 60%;
    cursor: pointer;
    z-index: 200000 !important;
    -webkit-backface-visibility: hidden;
    -webkit-transform: translateZ(0);
    transition: visibility .5s;
  }

    .quick-alo-phone .quick-alo-green .quick-alo-ph-circle {
      border-color: #00A1FF;
      opacity: 0.5;
    }

  .quick-alo-ph-circle {
    position: fixed;
    width: 160px;
    height: 160px;
    bottom: -30px;
    right: -20px;
    border: 2px solid #00A1FF;
    background-color: transparent;
    border-radius: 100%;
    opacity: .1;
    animation: quick-alo-circle-anim 1.2s infinite ease-in-out;
    transition: all .5s;
    transform-origin: 50% 50%;
  }

  .quick-alo-phone .quick-alo-green .quick-alo-ph-circle-fill {
    background-color: rgb(246, 202, 98);
    opacity: .75 !important;
  }

  .quick-alo-ph-circle-fill {
    position: fixed;
    width: 100px;
    height: 100px;
    bottom: 1px;
    right: 10px;
    background-color: rgba(0, 161, 255, 0.5);
    border-radius: 100%;
    border: 2px solid transparent;
    opacity: .1;
    animation: quick-alo-circle-fill-anim 2.3s infinite ease-in-out;
    transition: all .5s;
    transform-origin: 50% 50%;
  }

  .quick-alo-phone.quick-alo-green .quick-alo-ph-img-circle {
    background-color: #00A1FF;
  }

  .quick-alo-ph-img-circle {
    position: fixed;
    width: 60px;
    height: 60px;
    bottom: 20px;
    right: 30px;
    background: #00A1FF url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABrklEQVRYR82XjTEEQRCFX0dABlwEiAARkAEyIAJEoERACETARUAIJwIyeOqptfbm5qeP3lpTdVVXVzPd3/R0v+4zTLxsYv/4XwAkrwDsV6JyZmaLyKj1ESB5AOCpYfzazAQZttYFuDWz8zDvwE8OkNwF8NIwvjCz2SgAMkqSDuOzyDxYqgKSrwB2GhBKxHsHqGtLCiDDJ42Tj2Z27LLu2JQCnAK4a5x7M7Nth23XlhRgE8B74+SemempQtaKEpKsPUPo++sGOYCSIIU7zwJ05ficSLLkV6H/CIn7wEi2GRVkOVwFixEoREE/hz9DsR2TVKkp2zeSsI9bBUNnJNV4bhIA5cFhVCk2B5JCWVYhSEopjwAob6qa4QGQOKkqcj1iJSdIpmoqWEHIhr7Ph1BNgC4haxAPAC7UITPOc1UrCOXR12TlAnBAyKhAdHvPUg4pIn6AAYQc1ebG8QC+LXfD66XHU2HP7yKQlKhGODWu1gCTY/g7wCAaendNyltrRCQOIAERjCc/ejV1V4H3dp2ES4jU1vVJpXxpogoHSEE7oOEIp9G+/3c1OkArcpMDfAIqL6EhVS6JOAAAAABJRU5ErkJggg==") no-repeat center center;
    border-radius: 100%;
    border: 2px solid transparent;
    opacity: .99;
    animation: quick-alo-circle-img-anim 1s infinite ease-in-out;
    transform-origin: 50% 50%;
  }

  .quick-alo-phone .quick-alo-green .quick-alo-hover .quick-alo-ph-img-circle,
  .quick-alo-phone.quick-alo-green:hover .quick-alo-ph-img-circle {
    background-color: #ff0101;
  }

  @-moz-keyframes quick-alo-circle-anim {
    0% {
      -moz-transform: rotate(0) scale(.5) skew(1deg);
      opacity: .1;
      -moz-opacity: .1;
      -webkit-opacity: .1;
      -o-opacity: .1
    }

    30% {
      -moz-transform: rotate(0) scale(.7) skew(1deg);
      opacity: .5;
      -moz-opacity: .5;
      -webkit-opacity: .5;
      -o-opacity: .5
    }

    100% {
      -moz-transform: rotate(0) scale(1) skew(1deg);
      opacity: .6;
      -moz-opacity: .6;
      -webkit-opacity: .6;
      -o-opacity: .1
    }
  }

  @-webkit-keyframes quick-alo-circle-anim {
    0% {
      -webkit-transform: rotate(0) scale(.5) skew(1deg);
      -webkit-opacity: .1
    }

    30% {
      -webkit-transform: rotate(0) scale(.7) skew(1deg);
      -webkit-opacity: .5
    }

    100% {
      -webkit-transform: rotate(0) scale(1) skew(1deg);
      -webkit-opacity: .1
    }
  }

  @-o-keyframes quick-alo-circle-anim {
    0% {
      -o-transform: rotate(0) kscale(.5) skew(1deg);
      -o-opacity: .1
    }

    30% {
      -o-transform: rotate(0) scale(.7) skew(1deg);
      -o-opacity: .5
    }

    100% {
      -o-transform: rotate(0) scale(1) skew(1deg);
      -o-opacity: .1
    }
  }

  @-moz-keyframes quick-alo-circle-fill-anim {
    0% {
      -moz-transform: rotate(0) scale(.7) skew(1deg);
      opacity: .2
    }

    50% {
      -moz-transform: rotate(0) -moz-scale(1) skew(1deg);
      opacity: .2
    }

    100% {
      -moz-transform: rotate(0) scale(.7) skew(1deg);
      opacity: .2
    }
  }

  @-webkit-keyframes quick-alo-circle-fill-anim {
    0% {
      -webkit-transform: rotate(0) scale(.7) skew(1deg);
      opacity: .2
    }

    50% {
      -webkit-transform: rotate(0) scale(1) skew(1deg);
      opacity: .2
    }

    100% {
      -webkit-transform: rotate(0) scale(.7) skew(1deg);
      opacity: .2
    }
  }

  @-o-keyframes quick-alo-circle-fill-anim {
    0% {
      -o-transform: rotate(0) scale(.7) skew(1deg);
      opacity: .2
    }

    50% {
      -o-transform: rotate(0) scale(1) skew(1deg);
      opacity: .2
    }

    100% {
      -o-transform: rotate(0) scale(.7) skew(1deg);
      opacity: .2
    }
  }

  @-moz-keyframes quick-alo-circle-img-anim {
    0% {
      transform: rotate(0) scale(1) skew(1deg)
    }

    10% {
      -moz-transform: rotate(-25deg) scale(1) skew(1deg)
    }

    20% {
      -moz-transform: rotate(25deg) scale(1) skew(1deg)
    }

    30% {
      -moz-transform: rotate(-25deg) scale(1) skew(1deg)
    }

    40% {
      -moz-transform: rotate(25deg) scale(1) skew(1deg)
    }

    50% {
      -moz-transform: rotate(0) scale(1) skew(1deg)
    }

    100% {
      -moz-transform: rotate(0) scale(1) skew(1deg)
    }
  }

  @-webkit-keyframes quick-alo-circle-img-anim {
    0% {
      -webkit-transform: rotate(0) scale(1) skew(1deg)
    }

    10% {
      -webkit-transform: rotate(-25deg) scale(1) skew(1deg)
    }

    20% {
      -webkit-transform: rotate(25deg) scale(1) skew(1deg)
    }

    30% {
      -webkit-transform: rotate(-25deg) scale(1) skew(1deg)
    }

    40% {
      -webkit-transform: rotate(25deg) scale(1) skew(1deg)
    }

    50% {
      -webkit-transform: rotate(0) scale(1) skew(1deg)
    }

    100% {
      -webkit-transform: rotate(0) scale(1) skew(1deg)
    }
  }

  @-o-keyframes quick-alo-circle-img-anim {
    0% {
      -o-transform: rotate(0) scale(1) skew(1deg)
    }

    10% {
      -o-transform: rotate(-25deg) scale(1) skew(1deg)
    }

    20% {
      -o-transform: rotate(25deg) scale(1) skew(1deg)
    }

    30% {
      -o-transform: rotate(-25deg) scale(1) skew(1deg)
    }

    40% {
      -o-transform: rotate(25deg) scale(1) skew(1deg)
    }

    50% {
      -o-transform: rotate(0) scale(1) skew(1deg)
    }

    100% {
      -o-transform: rotate(0) scale(1) skew(1deg)
    }
  }

  @-moz-keyframes fadeInRight {
    0% {
      opacity: 0;
      -webkit-transform: translate3d(100%, 0, 0);
      -ms-transform: translate3d(100%, 0, 0);
      transform: translate3d(100%, 0, 0)
    }

    100% {
      opacity: 1;
      -webkit-transform: none;
      -ms-transform: none;
      transform: none
    }
  }

  @-webkit-keyframes fadeInRight {
    0% {
      opacity: 0;
      -webkit-transform: translate3d(100%, 0, 0);
      -ms-transform: translate3d(100%, 0, 0);
      transform: translate3d(100%, 0, 0)
    }

    100% {
      opacity: 1;
      -webkit-transform: none;
      -ms-transform: none;
      transform: none
    }
  }

  @-o-keyframes fadeInRight {
    0% {
      opacity: 0;
      -webkit-transform: translate3d(100%, 0, 0);
      -ms-transform: translate3d(100%, 0, 0);
      transform: translate3d(100%, 0, 0)
    }

    100% {
      opacity: 1;
      -webkit-transform: none;
      -ms-transform: none;
      transform: none
    }
  }

  .shake {
    animation: shake 0.82s cubic-bezier(.36, .07, .19, .97) both infinite;
    transform: translate3d(0, 0, 0);
    backface-visibility: hidden;
    perspective: 1000px;
  }

  @keyframes shake {

    10%, 90% {
      transform: translate3d(-1px, 0, 0);
    }

    20%, 80% {
      transform: translate3d(2px, 0, 0);
    }

    30%, 50%, 70% {
      transform: translate3d(-4px, 0, 0);
    }

    40%, 60% {
      transform: translate3d(4px, 0, 0);
    }
  }
</style>

<!-- Modern Sidebar Styles (unscoped to affect AdminLTE) -->
<style>
  /* ═══════════════════════════════════════════
     Sidebar — Subtle modernization
     Keep AdminLTE layout intact, just style upgrades
  ═══════════════════════════════════════════ */

  .main-sidebar {
    background: #02234e !important;
    border-right: none !important;
  }

  .main-sidebar .sidebar {
    padding-top: 6px;
  }

  /* User Panel */
  .main-sidebar .user-panel {
    border-bottom: 1px solid rgba(255,255,255,0.08) !important;
    padding-bottom: 12px !important;
  }

  .main-sidebar .user-panel .info > p {
    color: #fff !important;
    font-weight: 600;
  }

  .main-sidebar .user-panel .info > a {
    color: #4ade80 !important;
  }

  /* Menu items */
  .sidebar-menu > li > a {
    color: rgba(255,255,255,0.75) !important;
    font-size: 13px !important;
    padding: 10px 16px !important;
    border-left: 3px solid transparent !important;
    transition: all 0.15s ease !important;
  }

  .sidebar-menu > li > a:hover {
    background: rgba(255,255,255,0.05) !important;
    color: #fff !important;
    border-left-color: rgba(59,130,246,0.5) !important;
  }

  .sidebar-menu > li.active > a {
    background: rgba(37,99,235,0.15) !important;
    color: #60a5fa !important;
    border-left-color: #3b82f6 !important;
  }

  .sidebar-mini.sidebar-collapse .sidebar-menu > li > a {
    padding-left: 12px !important;
    padding-right: 0 !important;
  }

  .sidebar-menu > li > a > img {
    opacity: 0.75;
    transition: opacity 0.15s;
  }

  .sidebar-menu > li > a:hover > img,
  .sidebar-menu > li.active > a > img {
    opacity: 1;
  }

  /* Submenu */
  .sidebar-menu .treeview-menu {
    background: rgba(0,0,0,0.2) !important;
    padding: 4px 0 !important;
  }

  .sidebar-menu .treeview-menu > li > a {
    color: rgba(255,255,255,0.6) !important;
    font-size: 12.5px !important;
    padding: 8px 20px 8px 36px !important;
    transition: all 0.15s ease !important;
  }

  .sidebar-menu .treeview-menu > li > a:hover {
    color: #fff !important;
    background: rgba(255,255,255,0.04) !important;
  }

  .sidebar-menu .treeview-menu > li.active > a {
    color: #60a5fa !important;
    background: rgba(37,99,235,0.1) !important;
  }

  .sidebar-menu .treeview-menu > li > a > i {
    font-size: 6px !important;
    color: rgba(255,255,255,0.3);
  }

  .sidebar-menu .treeview-menu > li.active > a > i {
    color: #60a5fa !important;
  }

  /* Scrollbar */
  .sidebar::-webkit-scrollbar { width: 4px; }
  .sidebar::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.1); border-radius: 4px; }

  /* ═══════════ Header ═══════════ */
  .main-header .navbar {
    background: #02234e !important;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1) !important;
    border: none !important;
  }

  .main-header .logo {
    background: #02234e !important;
    border: none !important;
  }

  .main-header .logo span {
    color: #fff !important;
  }

  .main-header .sidebar-toggle {
    color: #ffffff !important;
    background: transparent !important;
  }

  .main-header .sidebar-toggle:hover {
    background: rgba(255,255,255,0.1) !important;
    color: #ffffff !important;
  }

  .main-header .navbar-custom-menu > .nav > li > a {
    color: rgba(255,255,255,0.85) !important;
    font-size: 13px !important;
  }

  .main-header .navbar-custom-menu > .nav > li > a:hover {
    background: rgba(255,255,255,0.1) !important;
    color: #fff !important;
  }

  .skin-black .main-header .navbar .navbar-custom-menu {
    gap: 2px !important;
    padding-right: 6px !important;
  }

  .skin-black .main-header .navbar .navbar-custom-menu > .nav.navbar-nav {
    gap: 2px !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  .skin-black .main-header .navbar .navbar-custom-menu > .nav.navbar-nav > li {
    margin: 0 !important;
  }

  .skin-black .main-header .navbar .navbar-custom-menu > .nav.navbar-nav > li > a {
    position: relative;
    display: inline-flex !important;
    vertical-align: middle !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 7px !important;
    height: 36px !important;
    min-width: 36px !important;
    margin: 0 !important;
    padding: 0 8px !important;
    border-radius: 18px !important;
    line-height: 1 !important;
  }

  .skin-black .main-header .navbar .navbar-custom-menu > .nav.navbar-nav > li > a > i:not(.cm-launcher__caret) {
    flex: 0 0 28px !important;
    width: 28px !important;
    height: 28px !important;
    margin: 0 !important;
    border-radius: 50% !important;
    font-size: 13px !important;
    line-height: 1 !important;
  }

  .skin-black .main-header .navbar .navbar-custom-menu > .nav.navbar-nav > li > a > img {
    width: 28px !important;
    height: 28px !important;
    margin: 0 !important;
  }

  .skin-black .main-header .navbar .navbar-custom-menu > .nav.navbar-nav > li > a > .label,
  .skin-black .main-header .navbar .navbar-custom-menu > .nav.navbar-nav > li > a > .rn-noti__badge {
    position: absolute !important;
    top: 3px !important;
    right: 5px !important;
    left: auto !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    min-width: 18px !important;
    height: 18px !important;
    margin: 0 !important;
    padding: 0 5px !important;
    border: 2px solid #fff !important;
    border-radius: 999px !important;
    font-size: 10px !important;
    font-weight: 800 !important;
    line-height: 1 !important;
  }

  .skin-black .main-header .navbar .navbar-custom-menu > .nav.navbar-nav > li > select.form-control {
    height: 36px !important;
    margin: 0 !important;
  }

  @media (max-width: 991px) {
    .skin-black .main-header .navbar .navbar-custom-menu > .nav.navbar-nav.rn-nav-overflow {
      padding: 6px !important;
    }
    .skin-black .main-header .navbar .navbar-custom-menu > .nav.navbar-nav.rn-nav-overflow > li > a {
      display: flex !important;
      justify-content: flex-start !important;
      height: auto !important;
      min-width: 0 !important;
      padding: 9px 10px !important;
      border-radius: 9px !important;
    }
  }

  /* Page title in header */
  .main-header .sidebar-toggle ~ .hidden-md,
  .main-header .sidebar-toggle .font-extra,
  .main-header .navbar-static-top .sidebar-toggle span.font-extra {
    color: #ffffff !important;
    font-weight: 600 !important;
  }

  /* ═══════════ Footer ═══════════ */
  .main-footer {
    display: block;
    height: 52px !important;
    padding: 0 18px !important;
    border: 0 !important;
    border-top: 1px solid #dce6ed !important;
    box-sizing: border-box;
    overflow: visible !important;
    color: #536a7b !important;
    background: rgba(255, 255, 255, .96) !important;
    box-shadow: 0 -8px 28px rgba(2, 35, 78, .08) !important;
    -webkit-backdrop-filter: blur(12px);
    backdrop-filter: blur(12px);
    line-height: normal !important;
    font-family: var(--bs-font-manrope), 'Sarabun', sans-serif;
    font-size: 12px !important;
  }

  .footer-inner {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto auto;
    align-items: center;
    gap: 14px;
    width: 100%;
    height: 100%;
    max-width: 100%;
  }

  .footer-identity,
  .footer-context,
  .footer-builds {
    display: flex;
    align-items: center;
    min-width: 0;
  }

  .footer-identity { gap: 12px; }

  .footer-mark {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 32px;
    width: 32px;
    height: 32px;
    border-radius: 10px;
    color: #fff;
    background: linear-gradient(135deg, #0b3a76, #02234e);
    box-shadow: 0 5px 12px rgba(2, 35, 78, .22);
    font-size: 12px;
  }

  .footer-identity-copy { min-width: 0; line-height: 1.18; }
  .footer-identity-copy small { display: block; margin-bottom: 2px; color: #8a9aa6; font-size: 9px; font-weight: 900; letter-spacing: 1.3px; text-transform: uppercase; }
  .footer-identity-copy div { overflow: hidden; color: #728493; font-size: 11px; text-overflow: ellipsis; white-space: nowrap; }
  .footer-brand-name { margin-left: 4px; color: #0b3a76; font-weight: 800; }

  .footer-info-divider {
    flex: 0 0 1px;
    width: 1px;
    height: 24px;
    background: #dce5eb;
  }

  .footer-context { justify-content: flex-end; }

  .footer-company {
    max-width: 520px;
    overflow: hidden;
    color: #425b6e;
    font-size: 12px;
    font-weight: 700;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .footer-company i { margin-right: 7px; color: #7990a2; }

  .footer-online {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    flex: 0 0 auto;
    height: 28px;
    padding: 0 10px;
    border: 1px solid #dce8ed;
    border-radius: 9px;
    color: #476274;
    background: #f5fafb;
    font-size: 11px;
    white-space: nowrap;
  }

  .footer-online strong { color: #087f75; font-size: 13px; }
  .footer-online small { color: #91a0ab; font-size: 10px; }

  .online-pulse {
    flex: 0 0 6px;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #24b99f;
    box-shadow: 0 0 0 3px rgba(36, 185, 159, .13);
  }

  .footer-builds { justify-content: flex-end; gap: 10px; }
  .build-badge { display: flex; align-items: baseline; gap: 5px; white-space: nowrap; }
  .build-badge small { color: #8294a2; font-size: 10px; font-weight: 900; letter-spacing: .8px; }
  .main-footer .build-badge strong { color: #344e62 !important; font-family: 'JetBrains Mono', 'Consolas', monospace; font-size: 12px; font-weight: 750; }
  .build-divider { width: 1px; height: 18px; background: #dce5eb; }

  body.dark-mode footer.main-footer {
    border-top-color: #28435c !important;
    color: #aebdca !important;
    background: rgba(11, 35, 56, .96) !important;
    box-shadow: 0 -8px 28px rgba(0, 0, 0, .22) !important;
  }

  body.dark-mode .footer-mark {
    background: linear-gradient(135deg, #2f74d8, #1748a8);
    box-shadow: 0 5px 12px rgba(23, 72, 168, .38);
  }

  body.dark-mode .footer-identity-copy small { color: #7d8a9c; }
  body.dark-mode .footer-identity-copy div { color: #93a3b3; }
  body.dark-mode .footer-company,
  body.dark-mode .footer-brand-name { color: #d5e0e8; }
  body.dark-mode .footer-company i { color: #8b9dae; }
  body.dark-mode .main-footer .build-badge strong { color: #d5e0e8 !important; }
  body.dark-mode .build-badge small { color: #7d8a9c; }
  body.dark-mode .footer-online { border-color: #315069; color: #b8c6d1; background: #153b57; }
  body.dark-mode .footer-online small { color: #8b9dae; }
  body.dark-mode .footer-info-divider,
  body.dark-mode .build-divider { background: #315069; }

  @media (max-width: 1366px) {
    .footer-inner { gap: 10px; }
    .footer-identity { gap: 9px; }
    .footer-company { max-width: 280px; }
    .footer-online > span:not(.online-pulse) { display: none; }
  }

  /* ═══════════ Content ═══════════ */
  .content-wrapper {
    background: #f8fafc !important;
  }

  /* ═══════════ Sidenav ═══════════ */
  .re-snav-backdrop {
    position: fixed; inset: 0; z-index: 1039; background: rgba(0,0,0,.35);
  }
  .re-snav-panel {
    position: fixed; top: 0; right: 0; bottom: 0; width: 250px; z-index: 1040;
    background: #fff; box-shadow: -4px 0 18px rgba(0,0,0,.15);
    display: flex; flex-direction: column;
  }
  .re-snav-header {
    display: flex; align-items: center; justify-content: space-between;
    padding: 14px 16px 12px; border-bottom: 1px solid #e9ecef;
  }
  .re-snav-title { font-size: 13px; font-weight: 700; color: #1e293b; letter-spacing: .02em; }
  .re-snav-close {
    background: none; border: none; cursor: pointer;
    padding: 2px 6px; color: #64748b; font-size: 16px; line-height: 1;
  }
  .re-snav-divider { height: 1px; background: linear-gradient(to right, #e0e0e0, transparent); margin: 0 16px; }
  .re-snav-body { flex: 1; overflow-y: auto; padding: 16px 12px; }

  .re-snav-slide-enter-active,
  .re-snav-slide-leave-active { transition: transform .25s ease; }
  .re-snav-slide-enter, .re-snav-slide-leave-to { transform: translateX(100%); }

  /* ═══════════════════════════════════════════
     Notification bell — due-date dropdown
  ═══════════════════════════════════════════ */
  .rn-noti > .rn-noti__bell { position: relative; }
  .rn-noti__badge {
    position: absolute;
    top: 7px;
    right: 2px;
    min-width: 18px;
    height: 18px;
    padding: 0 5px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 999px;
    border: 2px solid #fff;
    background: #E2574C;
    color: #fff;
    font-family: Manrope, Sarabun, sans-serif;
    font-size: 10px;
    font-weight: 800;
    line-height: 1;
    box-shadow: 0 2px 6px rgba(226, 87, 76, .45);
    animation: rnPulse 2.4s ease-out infinite;
  }
  @keyframes rnPulse {
    0%, 100% { box-shadow: 0 2px 6px rgba(226, 87, 76, .45), 0 0 0 0 rgba(226, 87, 76, .45); }
    70% { box-shadow: 0 2px 6px rgba(226, 87, 76, .45), 0 0 0 7px rgba(226, 87, 76, 0); }
  }
  .navbar-nav > .rn-noti > .rn-noti__panel {
    width: 388px !important;
    padding: 0 !important;
    margin: 8px 0 0 !important;
    border: 0 !important;
    border-radius: 16px !important;
    background: #fff !important;
    box-shadow: 0 20px 46px -18px rgba(2, 35, 78, .45), 0 4px 14px rgba(2, 35, 78, .08) !important;
    overflow: hidden;
    font-family: Manrope, Sarabun, sans-serif;
  }
  .rn-du__head {
    display: flex !important;
    align-items: center;
    gap: 12px;
    height: auto !important;
    padding: 15px 16px !important;
    border: 0 !important;
    border-radius: 0 !important;
    background: linear-gradient(120deg, #E1544A 0%, #EC7450 58%, #F49356 100%) !important;
    color: #fff !important;
    white-space: normal !important;
  }
  .rn-du__head-ico {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 40px;
    width: 40px;
    height: 40px;
    border: 1px solid rgba(255, 255, 255, .24);
    border-radius: 13px;
    background: rgba(255, 255, 255, .18);
    font-size: 16px;
  }
  .rn-du__head-text { display: flex; flex-direction: column; gap: 2px; flex: 1; min-width: 0; }
  .rn-du__head-title { font-size: 15px; font-weight: 800; letter-spacing: .01em; }
  .rn-du__head-sub { color: rgba(255, 255, 255, .82); font-size: 11px; font-weight: 500; }
  .rn-du__head-count {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 38px;
    padding: 5px 11px;
    border-radius: 11px;
    background: rgba(255, 255, 255, .2);
    font-size: 14px;
    font-weight: 800;
    font-variant-numeric: tabular-nums;
  }

  .rn-du__bar {
    display: flex !important;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 12px 16px 10px !important;
    color: #97A0AE;
    font-size: 11.5px;
    font-weight: 600;
  }
  .rn-du__sort { display: inline-flex; align-items: center; gap: 5px; }
  .rn-du__sort > i { font-size: 11px; }

  .rn-du__scroll {
    max-height: 316px;
    padding: 0 !important;
    overflow-y: auto;
    overscroll-behavior: contain;
  }
  .rn-du__scroll::-webkit-scrollbar { width: 7px; }
  .rn-du__scroll::-webkit-scrollbar-thumb { background: #CFD8E6; border-radius: 8px; }
  .rn-du__scroll::-webkit-scrollbar-thumb:hover { background: #B9C5D8; }
  .rn-du__scroll::-webkit-scrollbar-track { background: transparent; }
  .rn-du__item {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px 16px;
    border-bottom: 1px solid #F1F3F7;
    color: inherit;
    transition: background .14s ease;
  }
  .rn-du__item:last-child { border-bottom: 0; }
  .rn-du__item:hover,
  .rn-du__item:focus { background: #FBF7F5; text-decoration: none; }
  .rn-du__tile {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 38px;
    width: 38px;
    height: 38px;
    border-radius: 12px;
    background: #FDF0E9;
    color: #E2574C;
    font-size: 15px;
  }
  .rn-du__body { display: flex; flex-direction: column; gap: 3px; flex: 1; min-width: 0; }
  .rn-du__no {
    color: #16202E;
    font-size: 13.5px;
    font-weight: 800;
    letter-spacing: .01em;
  }
  .rn-du__meta {
    color: #8A93A2;
    font-size: 11.5px;
    font-weight: 500;
    line-height: 1.5;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .rn-du__meta > i { width: 12px; margin-right: 4px; color: #B6BECB; font-size: 10px; }
  .rn-du__chip {
    align-self: flex-start;
    display: inline-flex;
    align-items: center;
    gap: 5px;
    margin-top: 4px;
    padding: 3px 9px;
    border-radius: 999px;
    background: #FDEDE6;
    color: #D0533E;
    font-size: 10.5px;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
  }
  .rn-du__chip > i { font-size: 9.5px; }
  .rn-du__go {
    flex: 0 0 auto;
    margin-top: 12px;
    color: #C9D0DA;
    font-size: 11px;
    transition: transform .18s ease, color .18s ease;
  }
  .rn-du__item:hover .rn-du__go { transform: translateX(3px); color: #E2574C; }
  .rn-du__empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    padding: 34px 16px;
    color: #97A0AE;
    font-size: 12.5px;
    font-weight: 600;
  }
  .rn-du__empty > i { font-size: 26px; opacity: .45; }

  .rn-du__foot {
    display: flex !important;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 11px 16px !important;
    border-top: 1px solid #F0F2F6;
    color: #97A0AE;
    font-size: 11px;
    font-weight: 600;
  }
  .rn-du__close {
    padding: 0;
    border: 0;
    background: none;
    color: #6B7688;
    font-size: 11px;
    font-weight: 700;
    cursor: pointer;
    transition: color .15s ease;
  }
  .rn-du__close:hover, .rn-du__close:focus { color: #D0533E; outline: none; }

  /* ═══════════════════════════════════════════
     Tag bell — # มอบหมาย / @ กล่าวถึง
  ═══════════════════════════════════════════ */
  .rn-tag__badge { background: #E2574C; box-shadow: 0 2px 6px rgba(226, 87, 76, .45); }
  /* ไม่มีงานมอบหมายค้าง เหลือแต่ @ — ใช้โทนน้ำเงินและไม่ต้องเต้น */
  .rn-tag__badge--soft {
    background: #2F6FB8;
    box-shadow: 0 2px 6px rgba(47, 111, 184, .45);
    animation: none;
  }

  .rn-tp__head {
    display: flex !important;
    align-items: center;
    gap: 10px;
    padding: 15px 16px 13px !important;
    background: linear-gradient(135deg, #FFF3EE 0%, #FCE5DF 100%);
  }
  .rn-tp__head-title {
    color: #1F2937;
    font-size: 15px;
    font-weight: 800;
    letter-spacing: .01em;
  }
  .rn-tp__pill {
    padding: 3px 10px;
    border-radius: 999px;
    background: #FAD9D2;
    color: #C0392B;
    font-size: 10.5px;
    font-weight: 700;
    white-space: nowrap;
  }
  .rn-tp__close {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    margin-left: auto;
    padding: 0;
    border: 0;
    border-radius: 50%;
    background: none;
    color: #8A93A2;
    font-size: 15px;
    cursor: pointer;
    transition: background .15s ease, color .15s ease;
  }
  .rn-tp__close:hover,
  .rn-tp__close:focus { background: rgba(2, 35, 78, .08); color: #1F2937; outline: none; }

  .rn-tp__bar {
    display: flex !important;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 11px 16px 4px !important;
  }
  .rn-tp__day { color: #A3ABB8; font-size: 11.5px; font-weight: 600; }
  .rn-tp__mark {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 0;
    border: 0;
    background: none;
    color: #E2574C;
    font-size: 11.5px;
    font-weight: 700;
    cursor: pointer;
    transition: color .15s ease;
  }
  .rn-tp__mark:hover, .rn-tp__mark:focus { color: #B4372C; outline: none; }
  .rn-tp__mark > i { font-size: 12px; }

  .rn-tp__scroll {
    max-height: 430px;
    padding: 0 10px 4px !important;
    overflow-y: auto;
  }
  .rn-tp__group + .rn-tp__group { margin-top: 8px; }
  .rn-tp__group-head {
    display: flex;
    align-items: center;
    height: 42px;
    margin-bottom: 4px;
    padding: 0 16px;
    border-radius: 12px;
    color: #fff;
    font-size: 13.5px;
    font-weight: 800;
    letter-spacing: .01em;
  }
  .rn-tp__group--assign .rn-tp__group-head {
    background: linear-gradient(135deg, #DC4C3E 0%, #E2574C 45%, #F2A35C 100%);
  }
  .rn-tp__group--mention .rn-tp__group-head {
    background: linear-gradient(135deg, #1E4E8C 0%, #2F6FB8 60%, #4C8FD6 100%);
  }

  .rn-tp__item {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 11px 12px;
    border-radius: 14px;
    color: inherit;
    transition: background .15s ease;
  }
  .rn-tp__item:hover,
  .rn-tp__item:focus { background: #F6F8FC; text-decoration: none; }
  .rn-tp__tile {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 38px;
    width: 38px;
    height: 38px;
    border-radius: 12px;
    font-size: 15px;
  }
  .rn-tp__group--assign .rn-tp__tile { background: #FDECEA; color: #D63A2E; }
  .rn-tp__group--mention .rn-tp__tile { background: #E7F0FB; color: #2F6FB8; }
  .rn-tp__body {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
  }
  .rn-tp__kicker { color: #AEB6C2; font-size: 10.5px; font-weight: 700; }
  .rn-tp__title { color: #16202E; font-size: 13px; font-weight: 700; }
  .rn-tp__title > b { font-weight: 800; }
  .rn-tp__text {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    color: #56637A;
    font-size: 12px;
    line-height: 1.5;
    overflow: hidden;
  }
  .rn-tp__text--quote { color: #6B7688; }
  .rn-tp__meta { margin-top: 2px; color: #9AA3B2; font-size: 11px; font-weight: 500; }
  .rn-tp__chip {
    align-self: flex-start;
    display: inline-flex;
    align-items: center;
    gap: 5px;
    margin-top: 6px;
    padding: 3px 9px;
    border-radius: 999px;
    background: #FDECEA;
    color: #C0392B;
    font-size: 10.5px;
    font-weight: 700;
  }
  .rn-tp__chip > i { font-size: 9.5px; }
  .rn-tp__empty {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 9px 14px 11px;
    color: #A3ABB8;
    font-size: 11.5px;
    font-weight: 500;
  }
  .rn-tp__empty > i { font-size: 13px; opacity: .6; }

  .rn-tp__foot {
    display: flex !important;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 11px 16px !important;
    border-top: 1px solid #F0F2F6;
    color: #A3ABB8;
    font-size: 11px;
    font-weight: 600;
  }

  /* ═══════════════════════════════════════════
     Tools launcher — ยุบเมนูตั้งค่า/IT/Admin/Logs เป็นปุ่มเดียว
  ═══════════════════════════════════════════ */
  .cm-launcher { position: relative; }
  .navbar-custom-menu > .nav.navbar-nav > .cm-launcher > .cm-launcher__btn {
    border: 0 !important;
    background: transparent !important;
    color: #2B3445 !important;
    font-size: 12.5px;
    font-weight: 600;
    transition: background .18s ease, color .18s ease;
  }
  .navbar-custom-menu > .nav.navbar-nav > .cm-launcher > .cm-launcher__btn:hover,
  .navbar-custom-menu > .nav.navbar-nav > .cm-launcher > .cm-launcher__btn:focus {
    background: rgba(0, 112, 126, .08) !important;
    color: #00565F !important;
  }
  .navbar-custom-menu > .nav.navbar-nav > .cm-launcher > .cm-launcher__btn.is-open {
    background: #E1F0EF !important;
    color: #00565F !important;
  }
  /* ไอคอนซ้ายใช้วงกลมขนาดเดียวกับไอคอนอื่นบนแถบหัว — Site.css ให้พื้นเป็นขาวจาง จึงย้อมสีเองที่นี่ */
  .navbar-custom-menu > .nav.navbar-nav > .cm-launcher > .cm-launcher__btn > i.cm-launcher__grid {
    border: 0 !important;
    background: rgba(0, 112, 126, .12) !important;
    color: #00707E !important;
    transition: background .18s ease, color .18s ease;
  }
  .navbar-custom-menu > .nav.navbar-nav > .cm-launcher > .cm-launcher__btn.is-open > i.cm-launcher__grid {
    color: #00565F !important;
  }
  .navbar-custom-menu > .nav.navbar-nav > .cm-launcher > .cm-launcher__btn > i.cm-launcher__caret {
    width: auto !important;
    height: auto !important;
    border: 0 !important;
    border-radius: 0 !important;
    background: none !important;
    font-size: 11px;
    color: currentColor !important;
    opacity: .55;
    transition: transform .18s ease;
  }
  .cm-launcher__label { white-space: nowrap; }
  .cm-launcher__btn.is-open .cm-launcher__caret { transform: rotate(180deg); }

  body.dark-mode .navbar-custom-menu > .nav.navbar-nav > .cm-launcher > .cm-launcher__btn {
    background: rgba(255, 255, 255, .09) !important;
    color: #dbe4ee !important;
  }
  body.dark-mode .navbar-custom-menu > .nav.navbar-nav > .cm-launcher > .cm-launcher__btn:hover,
  body.dark-mode .navbar-custom-menu > .nav.navbar-nav > .cm-launcher > .cm-launcher__btn:focus,
  body.dark-mode .navbar-custom-menu > .nav.navbar-nav > .cm-launcher > .cm-launcher__btn.is-open {
    background: rgba(255, 255, 255, .17) !important;
    color: #fff !important;
  }
  body.dark-mode .navbar-custom-menu > .nav.navbar-nav > .cm-launcher > .cm-launcher__btn > i.cm-launcher__grid,
  body.dark-mode .navbar-custom-menu > .nav.navbar-nav > .cm-launcher > .cm-launcher__btn.is-open > i.cm-launcher__grid {
    color: #5FD4C8 !important;
  }

  .cm-panel {
    position: absolute;
    top: 100%;
    right: 0;
    z-index: 1030;
    margin-top: 2px;
    padding: 10px;
    width: 560px;
    max-width: calc(100vw - 24px);
    max-height: calc(100vh - 90px);
    overflow-y: auto;
    border-radius: 14px;
    background: #fff;
    border: 1px solid rgba(0, 0, 0, .06);
    box-shadow: 0 14px 32px rgba(0, 0, 0, .14), 0 4px 10px rgba(0, 0, 0, .06);
  }
  .cm-panel__group { --mc: #5f6368; }
  .cm-panel__group + .cm-panel__group {
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px solid #F0F2F5;
  }
  .cm-panel__title {
    display: flex;
    align-items: center;
    gap: 7px;
    margin: 0 0 6px;
    padding: 0 4px;
    color: var(--mc);
    font-size: 11px;
    font-weight: 800;
    letter-spacing: .02em;
    text-transform: uppercase;
  }
  .cm-panel__title-ico { font-size: 10.5px; opacity: .85; }
  .cm-panel__grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 4px;
  }
  .cm-panel__chip {
    display: flex !important;
    align-items: center;
    gap: 9px;
    min-height: 42px;
    padding: 6px 9px !important;
    border-radius: 9px;
    text-decoration: none !important;
    transition: background .15s ease;
  }
  .cm-panel__chip:hover,
  .cm-panel__chip:focus { background: #F3F5F8; }
  .cm-panel__chip-ico {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 28px;
    height: 28px;
    border-radius: 8px;
    font-size: 12px;
    color: var(--mc);
    background: rgba(0, 0, 0, .05);
    transition: background .15s ease, color .15s ease;
  }
  .cm-panel__chip:hover .cm-panel__chip-ico { color: #fff; background: var(--mc); }
  .cm-panel__chip-body { min-width: 0; line-height: 1.25; }
  .cm-panel__chip-code {
    display: block;
    color: var(--mc);
    font-size: 10px;
    font-weight: 800;
    letter-spacing: .05em;
  }
  .cm-panel__chip-text {
    display: block;
    color: #3C4453;
    font-size: 12px;
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  /* ≤991px ปุ่มย้ายไปอยู่ใน rn-nav-overflow แล้ว จัดให้เป็นแถวเต็มเหมือนเมนูอื่นในลิสต์ */
  @media (max-width: 991px) {
    .navbar-custom-menu > .nav.navbar-nav > .cm-launcher > .cm-launcher__btn {
      justify-content: flex-start;
      width: 100%;
      height: 38px !important;
      margin: 0 !important;
      padding: 0 10px !important;
      border-radius: 9px;
    }
    .cm-launcher__label { flex: 1 1 auto; }
    .cm-launcher__btn > .cm-launcher__caret { margin-left: auto; }

    /* panel แบบ absolute จะถูก overflow-y ของ dropdown ตัดหัวตัดท้าย จึงให้ไหลอยู่ในลิสต์แทน */
    .cm-panel {
      position: static;
      width: auto;
      max-width: none;
      max-height: none;
      overflow: visible;
      margin: 2px 0 4px;
      padding: 2px 0 2px 8px;
      border: 0;
      border-radius: 0;
      background: transparent;
      box-shadow: none;
    }
    .cm-panel__grid { grid-template-columns: minmax(0, 1fr); }
    .cm-panel__group + .cm-panel__group { margin-top: 6px; padding-top: 6px; }
    .cm-panel__chip { min-height: 40px; }
  }

  /* ═══════════════════════════════════════════
     Comment bell — 💬 มีคนตอบใน task ที่เราเกี่ยวข้อง
  ═══════════════════════════════════════════ */
  .rn-cmt__badge {
    background: #1E9E7E;
    box-shadow: 0 2px 6px rgba(30, 158, 126, .45);
    animation: none;
  }
  .rn-tp--cmt .rn-tp__head { background: linear-gradient(135deg, #EDF9F4 0%, #DCF1E8 100%); }
  .rn-tp--cmt .rn-tp__pill { background: #CFEDE1; color: #14785F; }
  .rn-tp--cmt .rn-tp__mark { color: #1E9E7E; }
  .rn-tp--cmt .rn-tp__mark:hover,
  .rn-tp--cmt .rn-tp__mark:focus { color: #14705B; }
  .rn-tp__group--comment .rn-tp__group-head {
    background: linear-gradient(135deg, #14705B 0%, #1E9E7E 55%, #4FC3A1 100%);
  }
  .rn-tp__group--comment .rn-tp__tile { background: #E4F5EF; color: #14785F; }
  .rn-tp__group--comment .rn-tp__chip { background: #E4F5EF; color: #14785F; }
  /* Revision (PROD) worklist */
  .rp {
    --rp-ink: #0b1f3f;
    --rp-slate: #334155;
    --rp-muted: #5b6b85;
    --rp-line: #cfdaea;
    --rp-wait: #1d4ed8;
    --rp-done: #059669;
    --rp-late: #be123c;
    --rp-blue: #1d4ed8;
    --rp-navy: #03316e;
    margin: -6px -4px -2px;
  }
  .rp__bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    margin: 0 2px 9px;
    color: var(--rp-muted);
    font-size: 11.5px;
    font-weight: 600;
  }
  .rp__sort { display: inline-flex; align-items: center; gap: 5px; }
  .rp__sort > i { font-size: 11px; }
  .rp__list { list-style: none; margin: 0; padding: 0; }
  .rp__group {
    display: flex;
    align-items: center;
    gap: 7px;
    margin: 0 2px 8px;
    color: var(--rp-ink);
    font-size: 12.5px;
    font-weight: 700;
  }
  .rp__list + .rp__group { margin-top: 16px; }
  .rp__group-dot { width: 8px; height: 8px; border-radius: 50%; background: var(--rp-muted); }
  .rp__group-dot.is-S { background: var(--rp-blue); }
  .rp__group-dot.is-T { background: #6d28d9; }
  .rp__group-count {
    min-width: 20px;
    padding: 0 7px;
    border-radius: 999px;
    background: var(--rp-navy);
    color: #fff;
    font-size: 11px;
    line-height: 18px;
    text-align: center;
  }
  .rp__row {
    position: relative;
    display: flex;
    align-items: center;
    gap: 18px;
    padding: 13px 16px 13px 22px;
    border: 1px solid var(--rp-line);
    border-radius: 13px;
    background: linear-gradient(90deg, rgba(29, 78, 216, .09) 0, #fff 18%);
    box-shadow: 0 1px 2px rgba(11, 31, 63, .06);
    overflow: hidden;
    animation: rpIn .32s cubic-bezier(.22,.9,.3,1) both;
    animation-delay: calc(var(--i, 0) * 45ms);
    transition: border-color .22s ease, box-shadow .22s ease;
  }
  .rp__row + .rp__row { margin-top: 8px; }
  .rp__row:hover { border-color: #93add6; box-shadow: 0 6px 16px -8px rgba(3, 49, 110, .35); }
  .rp__rail {
    position: absolute;
    left: 0; top: 0; bottom: 0;
    width: 5px;
    background: linear-gradient(180deg, var(--rp-blue) 0%, var(--rp-navy) 100%);
    transition: background .28s ease;
  }
  .rp__row.is-done .rp__rail { background: var(--rp-done); }
  .rp__row.is-done {
    border-color: rgba(16, 185, 129, .3);
    background: linear-gradient(90deg, rgba(16, 185, 129, .11) 0, #fbfefc 16%);
  }
  .rp__main { flex: 1 1 auto; min-width: 0; }
  .rp__meta { display: flex; align-items: center; gap: 9px; flex-wrap: wrap; }
  .rp__copy {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    margin-right: -3px;
    padding: 0;
    border: 1px solid #bcd0ee;
    border-radius: 7px;
    background: #eaf1fd;
    color: var(--rp-blue);
    font-size: 11.5px;
    cursor: pointer;
    transition: background .16s ease, color .16s ease, border-color .16s ease, transform .16s ease;
  }
  .rp__copy:hover, .rp__copy:focus { background: var(--rp-blue); border-color: var(--rp-blue); color: #fff; outline: none; }
  .rp__copy.is-copied { background: var(--rp-done); border-color: var(--rp-done); color: #fff; transform: scale(1.08); }
  .rp__doc {
    font-size: 13.5px;
    font-weight: 800;
    letter-spacing: .3px;
    color: var(--rp-blue) !important;
    text-decoration: none;
    border-bottom: 1px solid transparent;
  }
  .rp__doc:hover { border-bottom-color: currentColor; }
  .rp__item { font-size: 11px; font-weight: 700; color: var(--rp-muted); }
  .rp__due {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 2px 8px;
    border-radius: 999px;
    background: #e6edf7;
    font-size: 11px;
    font-weight: 700;
    color: var(--rp-slate);
  }
  .rp__due > i { font-size: 10px; }
  .rp__due.is-late { background: rgba(190, 18, 60, .12); color: var(--rp-late); }
  .rp__row.is-done .rp__due { background: rgba(16, 185, 129, .12); color: #047857; }
  .rp__subject {
    margin: 5px 0 0;
    font-family: var(--bs-font-manrope);
    font-size: 12.5px;
    line-height: 1.5;
    color: var(--rp-slate);
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    transition: opacity .22s ease;
  }
  .rp__row.is-done .rp__subject { opacity: .55; }
  .rp__flow { display: flex; align-items: flex-end; gap: 9px; flex: 0 0 auto; }
  .rp__tag {
    display: block;
    font-size: 9px;
    font-weight: 800;
    letter-spacing: 1.1px;
    color: var(--rp-muted);
    margin-bottom: 3px;
    text-align: left;
  }
  .rp__uat {
    min-width: 96px;
    padding: 6px 12px 7px;
    border: 1px solid #bcd0ee;
    border-radius: 10px;
    background: #eaf1fd;
    cursor: pointer;
    transition: background .18s ease, border-color .18s ease, transform .18s ease;
  }
  .rp__uat:hover { background: #dbe7fb; border-color: var(--rp-blue); }
  .rp__uat.is-copied { background: rgba(16,185,129,.12); border-color: var(--rp-done); transform: scale(1.04); }
  .rp__code {
    display: block;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: .6px;
    color: var(--rp-navy);
    font-variant-numeric: tabular-nums;
  }
  .rp__arrow { font-size: 11px; color: #7f9cc9; margin-bottom: 10px; transition: color .28s ease; }
  .rp__row.is-done .rp__arrow { color: var(--rp-done); }
  .rp__prod { position: relative; margin: 0; font-weight: 400; }
  .rp__prod > input {
    width: 180px;
    height: 38px;
    padding: 0 30px 0 12px;
    border: 1px solid #94a8c6;
    border-radius: 10px;
    background: #fff;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: .6px;
    color: var(--rp-ink);
    font-variant-numeric: tabular-nums;
    transition: border-color .18s ease, box-shadow .18s ease;
  }
  .rp__prod > input::placeholder { font-weight: 500; letter-spacing: 0; color: #8696b0; }
  .rp__prod > input:focus {
    outline: none;
    border-color: var(--rp-blue);
    box-shadow: 0 0 0 3px rgba(29, 78, 216, .18);
  }
  .rp__ok {
    position: absolute;
    right: 10px;
    bottom: 13px;
    font-size: 11px;
    color: var(--rp-done);
    opacity: 0;
    transform: scale(.6);
    transition: opacity .2s ease, transform .2s ease;
  }
  .rp__row.is-done .rp__ok { opacity: 1; transform: scale(1); }
  .rp__row.is-done .rp__prod > input {
    border-color: var(--rp-done);
    background: rgba(16, 185, 129, .06);
    box-shadow: 0 0 0 3px rgba(16, 185, 129, .1);
  }
  .rp__empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    padding: 46px 16px;
    color: var(--rp-muted);
    font-size: 13px;
    font-weight: 600;
  }
  .rp__empty > i { font-size: 30px; color: var(--rp-done); opacity: .5; }
  .rp__foot { display: flex; align-items: center; justify-content: space-between; width: 100%; gap: 12px; }
  .rp__status { display: flex; align-items: center; gap: 11px; min-width: 0; }
  .rp__ring {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 38px;
    width: 38px;
    height: 38px;
    border-radius: 50%;
    background: conic-gradient(#b8c8e2 0, #b8c8e2 var(--p, 0%), #dfe7f3 var(--p, 0%));
    color: #8696b0;
    font-size: 12px;
    transition: background .3s ease, color .3s ease;
  }
  .rp__ring::before {
    content: '';
    position: absolute;
    inset: 4px;
    border-radius: 50%;
    background: #f8fafc;
  }
  .rp__ring > i { position: relative; }
  .rp__ring.is-on {
    background: conic-gradient(var(--rp-blue) 0, var(--rp-blue) var(--p, 0%), #dbe7fb var(--p, 0%));
    color: var(--rp-blue);
  }
  .rp__status-text { display: flex; flex-direction: column; gap: 1px; min-width: 0; }
  .rp__status-text > b {
    color: var(--rp-ink);
    font-size: 13px;
    font-weight: 800;
    font-variant-numeric: tabular-nums;
  }
  .rp__status-text > small { color: var(--rp-muted); font-size: 11px; font-weight: 500; }
  .rp__actions { display: flex; align-items: center; gap: 8px; flex: 0 0 auto; }
  .rp__btn {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    height: 38px;
    padding: 0 18px;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
    transition: background .16s ease, border-color .16s ease, box-shadow .16s ease, opacity .16s ease;
  }
  .rp__btn--ghost {
    border: 1px solid #94a8c6;
    background: #fff;
    color: var(--rp-navy);
  }
  .rp__btn--ghost:hover, .rp__btn--ghost:focus { border-color: var(--rp-navy); background: #eaf1fd; outline: none; }
  .rp__btn--save {
    border: 1px solid transparent;
    background: linear-gradient(135deg, #1d4ed8 0%, #03316e 100%);
    color: #fff;
    box-shadow: 0 6px 16px -8px rgba(3, 49, 110, .9);
  }
  .rp__btn--save:hover:not(:disabled),
  .rp__btn--save:focus:not(:disabled) {
    background: linear-gradient(135deg, #1e40af 0%, #022657 100%);
    outline: none;
  }
  .rp__btn--save:disabled {
    background: #b8c6dc;
    box-shadow: none;
    cursor: not-allowed;
    opacity: .75;
  }

  .rp-modal .modal-content {
    border: 0;
    border-radius: 18px;
    overflow: hidden;
    box-shadow: 0 30px 70px -28px rgba(3, 49, 110, .6), 0 6px 18px rgba(11, 31, 63, .1);
  }
  .rp-modal .modal-header.modal-header-primary {
    position: relative;
    align-items: flex-start !important;
    padding: 22px 20px 18px !important;
    border-bottom: 0 !important;
    background: linear-gradient(135deg, #03316e 0%, #0a3f8f 55%, #1d4ed8 100%) !important;
  }
  .rp-modal .modal-header.modal-header-primary::before {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0;
    height: 4px;
    background: linear-gradient(90deg, #60a5fa 0%, #93c5fd 50%, #ffffff 100%);
    opacity: .85;
  }
  .rp-modal .modal-header.modal-header-primary::after {
    background: rgba(255, 255, 255, .12);
  }
  .rp-modal .modal-head { align-items: flex-start; }
  .rp-modal .modal-head__icon {
    width: 46px;
    height: 46px;
    flex: 0 0 46px;
    border-radius: 14px;
    border: 1px solid rgba(255, 255, 255, .28);
    background: rgba(255, 255, 255, .14);
    color: #fff;
    font-size: 19px;
    box-shadow: 0 8px 18px -10px rgba(0, 0, 0, .6);
  }
  .rp-modal .modal-head__text { gap: 3px; }
  .rp-head__kicker {
    color: #a9c6f5;
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 1.4px;
    text-transform: uppercase;
  }
  .rp-modal .modal-head__title {
    display: flex;
    align-items: center;
    gap: 9px;
    flex-wrap: wrap;
    color: #fff;
    font-size: 17px;
    font-weight: 800;
    white-space: normal;
    overflow: visible;
  }
  .rp-head__pill {
    padding: 3px 11px;
    border-radius: 999px;
    background: #fff;
    color: #03316e;
    font-size: 11px;
    font-weight: 800;
    white-space: nowrap;
  }
  .rp-modal .modal-head__sub { color: #cfe0fb; font-size: 12.5px; }
  .rp-modal .modal-header .close {
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    margin: 0 !important;
    border: 1px solid rgba(255, 255, 255, .3) !important;
    border-radius: 10px !important;
    background: rgba(255, 255, 255, .12) !important;
    color: #fff !important;
    font-size: 20px !important;
    font-weight: 400 !important;
    opacity: 1 !important;
    text-shadow: none !important;
    transition: background .15s ease, color .15s ease, border-color .15s ease;
  }
  .rp-modal .modal-header .close:hover,
  .rp-modal .modal-header .close:focus {
    border-color: #fff !important;
    background: #fff !important;
    color: #03316e !important;
  }
  .rp-modal .modal-body { padding: 16px 20px 18px !important; background: #f4f7fc; }
  .rp-modal .modal-footer.modal-footer-actions { padding: 14px 20px !important; background: #fff; border-top: 1px solid #d5deeb; }
  @keyframes rpIn {
    from { opacity: 0; transform: translateY(9px); }
    to { opacity: 1; transform: none; }
  }
  @media (max-width: 767px) {
    .rp__row { flex-direction: column; align-items: stretch; gap: 12px; }
    .rp__flow { justify-content: space-between; }
    .rp__prod > input { width: 100%; min-width: 130px; }
  }

  @media (prefers-reduced-motion: reduce) {
    .rn-noti__badge { animation: none; }
    .rn-du__item, .rn-du__go { transition: none; }
    .rp__row { animation: none; }
    .rp__row, .rp__rail, .rp__uat, .rp__arrow, .rp__ok, .rp__subject, .rp__prod > input, .rp__copy { transition: none; }
  }

  .nc-modal .modal-content {
    border: 0;
    border-radius: 18px;
    overflow: hidden;
    box-shadow: 0 30px 70px -28px rgba(15, 23, 42, .5), 0 6px 18px rgba(15, 23, 42, .08);
  }
  .nc-modal .modal-header.modal-header-primary {
    padding: 18px 20px !important;
    border-bottom: 1px solid #e1eee8 !important;
    background: linear-gradient(135deg, #ebfaf3 0%, #f7fcfa 48%, #f2fbe6 100%) !important;
  }
  .nc-modal .modal-header.modal-header-primary::after {
    height: 2px;
    background: linear-gradient(90deg, rgba(16, 185, 129, 0) 0%, rgba(16, 185, 129, .45) 45%, rgba(163, 230, 53, 0) 100%);
  }
  .nc-modal .modal-head__icon {
    width: 44px;
    height: 44px;
    flex: 0 0 44px;
    border-radius: 14px;
    background: linear-gradient(135deg, #0f4f40 0%, #10b981 100%);
    color: #dcffec;
    font-size: 17px;
    box-shadow: 0 10px 18px -10px rgba(16, 185, 129, .95);
  }
  .nc-modal .modal-head__text { gap: 2px; }
  .nc-head__kicker {
    color: #3f9b7c;
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 1.4px;
    text-transform: uppercase;
  }
  .nc-modal .modal-head__title { color: #0f2a24; font-size: 17px; font-weight: 800; }
  .nc-modal .modal-header .close {
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    margin: 0 !important;
    border: 1px solid #dfe9e5 !important;
    border-radius: 10px !important;
    background: #fff !important;
    color: #7b8a86 !important;
    font-size: 20px !important;
    font-weight: 400 !important;
    opacity: 1 !important;
    text-shadow: none !important;
    transition: background .15s ease, color .15s ease, border-color .15s ease;
  }
  .nc-modal .modal-header .close:hover,
  .nc-modal .modal-header .close:focus {
    border-color: #c5d6cf !important;
    background: #f3f8f6 !important;
    color: #334155 !important;
  }
  .nc-modal .modal-body { padding: 20px !important; }
  .nc-modal .modal-footer.modal-footer-actions { padding: 12px 20px !important; }
  .nc-modal .nc__save {
    margin-left: auto;
    height: 38px;
    padding: 0 22px;
    border-radius: 11px;
    font-size: 13px;
    font-weight: 700;
  }

  .nc {
    display: grid;
    grid-template-columns: 250px minmax(0, 1fr);
    gap: 22px;
    align-items: stretch;
  }
  .nc__card {
    position: relative;
    display: flex;
    flex-direction: column;
    border-radius: 18px;
    overflow: hidden;
    color: #e8fff6;
    background:
      radial-gradient(120% 70% at 100% 0%, rgba(183, 243, 107, .22) 0%, transparent 55%),
      radial-gradient(90% 60% at 0% 100%, rgba(16, 185, 129, .35) 0%, transparent 60%),
      linear-gradient(160deg, #0b3a30 0%, #0f4f40 55%, #136b55 100%);
    box-shadow: 0 22px 40px -24px rgba(6, 60, 46, .9), inset 0 1px 0 rgba(255, 255, 255, .08);
    transition: box-shadow .3s ease;
  }
  .nc-modal.in .nc__card { animation: ncRise .5s cubic-bezier(.2, .8, .2, 1) both; }
  .nc__card::before {
    content: '';
    position: absolute;
    top: 0; right: 0; bottom: 0; left: 0;
    background: repeating-linear-gradient(135deg, rgba(255, 255, 255, .035) 0 1px, transparent 1px 9px);
    pointer-events: none;
  }
  .nc.is-saved .nc__card {
    box-shadow: 0 0 0 2px rgba(52, 211, 153, .6), 0 22px 40px -24px rgba(6, 60, 46, .9), inset 0 1px 0 rgba(255, 255, 255, .08);
  }
  .nc__card-body {
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 22px 20px 18px;
  }
  .nc__avatar {
    width: 58px;
    height: 58px;
    flex: 0 0 58px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;
    border-radius: 18px;
    background: linear-gradient(135deg, #c4f57a 0%, #34d399 100%);
    color: #073b2e;
    font-size: 21px;
    font-weight: 800;
    letter-spacing: .5px;
    box-shadow: 0 0 0 4px rgba(255, 255, 255, .08), 0 10px 20px -10px rgba(183, 243, 107, .8);
  }
  .nc__avatar i { font-size: 22px; opacity: .7; }
  .nc__who { min-width: 0; max-width: 100%; }
  .nc__name {
    color: #fff;
    font-size: 18px;
    font-weight: 800;
    line-height: 1.3;
    word-break: break-word;
  }
  .nc__name.is-empty { color: rgba(232, 255, 246, .45); font-weight: 600; }
  .nc__nick {
    margin-top: 2px;
    color: #b7f36b;
    font-size: 13px;
    font-style: italic;
    word-break: break-word;
  }
  .nc__lines {
    width: 100%;
    margin: 18px 0 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .nc__lines li {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
    font-size: 12.5px;
  }
  .nc__lines li i {
    width: 26px;
    height: 26px;
    flex: 0 0 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    background: rgba(255, 255, 255, .09);
    color: #9ff0c9;
    font-size: 11px;
  }
  .nc__lines li span { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .nc__lines li.is-empty span { color: rgba(232, 255, 246, .4); }
  .nc__stub {
    position: relative;
    padding: 16px 20px 18px;
    border-top: 2px dashed rgba(255, 255, 255, .18);
    background: rgba(3, 30, 24, .35);
  }
  .nc__stub::before,
  .nc__stub::after {
    content: '';
    position: absolute;
    top: -10px;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #fff;
  }
  .nc__stub::before { left: -9px; }
  .nc__stub::after { right: -9px; }
  .nc-modal .nc__code {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    color: #b7f36b;
    font-family: Consolas, 'SFMono-Regular', Menlo, monospace;
    font-size: 17px;
    font-weight: 700;
    letter-spacing: 1.5px;
    text-decoration: none;
  }
  .nc-modal .nc__code.is-pending { color: rgba(232, 255, 246, .35); font-size: 15px; }
  .nc-modal .nc__code.is-pending i { font-size: 12px; }
  .nc-modal a.nc__code {
    margin-left: -10px;
    padding: 6px 12px 6px 10px;
    border-radius: 10px;
    background: rgba(183, 243, 107, .12);
    animation: ncStamp .55s cubic-bezier(.2, 1.4, .4, 1) both;
    transition: background .15s ease, color .15s ease;
  }
  .nc-modal a.nc__code:hover,
  .nc-modal a.nc__code:focus {
    background: rgba(183, 243, 107, .22);
    color: #d4ff94;
    outline: none;
  }
  .nc__stamp { color: #34d399; font-size: 15px; }
  .nc__go { font-size: 12px; transition: transform .15s ease; }
  .nc-modal a.nc__code:hover .nc__go { transform: translateX(3px); }
  .nc__stub-hint {
    margin: 8px 0 0;
    color: rgba(232, 255, 246, .6);
    font-size: 11.5px;
    line-height: 1.5;
  }

  .nc__form { display: flex; flex-direction: column; gap: 16px; min-width: 0; }
  .nc__grid { display: grid; gap: 14px; }
  .nc__grid--3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }
  .nc__grid--2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .nc__field {
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 0;
    margin: 0;
    font-weight: 400;
  }
  .nc__label { color: #334155; font-size: 12px; font-weight: 700; letter-spacing: .2px; }
  .nc__field.is-required .nc__label::after { content: ' *'; color: #e11d48; }
  .nc-modal .nc__field .form-control {
    height: 40px;
    padding: 8px 12px;
    border: 1px solid #dbe4e1;
    border-radius: 11px;
    background: #f8fbfa;
    box-shadow: none;
    font-size: 13.5px;
    transition: border-color .15s ease, box-shadow .15s ease, background .15s ease;
  }
  .nc-modal .nc__field .form-control:hover { border-color: #b9cbc5; }
  .nc-modal .nc__field .form-control:focus {
    border-color: #10b981 !important;
    background: #fff;
    box-shadow: 0 0 0 4px rgba(16, 185, 129, .15);
    outline: none;
  }
  .nc__input { position: relative; display: block; }
  .nc__input > i {
    position: absolute;
    top: 50%;
    left: 13px;
    z-index: 1;
    transform: translateY(-50%);
    color: #94a3b8;
    font-size: 12px;
    pointer-events: none;
    transition: color .15s ease;
  }
  .nc-modal .nc__input .form-control { padding-left: 36px; }
  .nc__input:focus-within > i { color: #10b981; }
  .nc__hint { color: #94a3b8; font-size: 11px; }
  .nc__note {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    margin-top: auto;
    padding: 13px 14px;
    border: 1px solid #fde9b5;
    border-radius: 14px;
    background: linear-gradient(135deg, #fffbeb 0%, #fefaf0 100%);
  }
  .nc__note-icon {
    width: 30px;
    height: 30px;
    flex: 0 0 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    background: #fde68a;
    color: #a16207;
    font-size: 13px;
  }
  .nc__note b { display: block; margin-bottom: 2px; color: #92400e; font-size: 12.5px; }
  .nc__note p { margin: 0; color: #78591c; font-size: 12.5px; line-height: 1.55; }
  .nc__note a { color: #b45309; font-weight: 700; text-decoration: underline; text-underline-offset: 2px; }

  body.dark-mode .nc-modal .modal-header.modal-header-primary {
    border-bottom-color: #2d4057 !important;
    background: linear-gradient(135deg, #12322b 0%, #172638 100%) !important;
  }
  body.dark-mode .nc-modal .modal-head__title { color: #e6edf3; }
  body.dark-mode .nc-head__kicker { color: #6fd3ad; }
  body.dark-mode .nc-modal .modal-header .close {
    border-color: #2d4057 !important;
    background: #1e2a3a !important;
    color: #8b9dae !important;
  }
  body.dark-mode .nc__label { color: #c9d1d9; }
  body.dark-mode .nc__stub::before,
  body.dark-mode .nc__stub::after { background: #1e2a3a; }
  body.dark-mode .nc-modal .nc__field .form-control:focus { box-shadow: 0 0 0 4px rgba(16, 185, 129, .22) !important; }
  body.dark-mode .nc__note { border-color: rgba(250, 204, 21, .22); background: rgba(250, 204, 21, .07); }
  body.dark-mode .nc__note-icon { background: rgba(250, 204, 21, .18); color: #facc15; }
  body.dark-mode .nc__note b { color: #facc15; }
  body.dark-mode .nc__note p { color: #d6c79a; }
  body.dark-mode .nc__note a { color: #fbbf24; }

  @keyframes ncRise {
    from { opacity: 0; transform: translateY(10px) scale(.98); }
    to { opacity: 1; transform: none; }
  }
  @keyframes ncStamp {
    0% { opacity: 0; transform: scale(1.6) rotate(-6deg); }
    60% { opacity: 1; transform: scale(.94) rotate(1deg); }
    100% { opacity: 1; transform: none; }
  }
  @media (max-width: 991px) {
    .nc { grid-template-columns: minmax(0, 1fr); gap: 18px; }
    .nc__card-body {
      display: grid;
      grid-template-columns: auto minmax(0, 1fr);
      align-items: center;
      column-gap: 14px;
    }
    .nc__avatar { margin-bottom: 0; }
    .nc__lines { grid-column: 1 / -1; flex-direction: row; flex-wrap: wrap; gap: 8px 18px; margin-top: 14px; }
    .nc__lines li { flex: 1 1 180px; }
  }
  @media (max-width: 767px) {
    .nc__grid--3,
    .nc__grid--2 { grid-template-columns: minmax(0, 1fr); }
  }
  @media (prefers-reduced-motion: reduce) {
    .nc-modal.in .nc__card,
    .nc-modal a.nc__code { animation: none; }
  }

  .re-snav-fade-enter-active,
  .re-snav-fade-leave-active { transition: opacity .2s ease; }
  .re-snav-fade-enter, .re-snav-fade-leave-to { opacity: 0; }
</style>
